// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27none%27 stroke=%27%23667085%27 stroke-width=%272%27%3E%3Cpath d=%27m4 6 4 4 4-4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #f5f7fb;
  --surface: #ffffff;
  --surface-2: #f9fafc;
  --border: #e6e9f0;
  --border-strong: #d0d5dd;
  --text: #101828;
  --muted: #667085;
  --subtle: #98a2b3;
  --accent: #1f75e0;
  --accent-soft: #eaf2fd;
  --accent-ink: #ffffff;
  --success: #12b76a;
  --success-soft: #ecfdf3;
  --danger: #f04438;
  --danger-soft: #fef3f2;
  --warning: #f79009;
  --warning-soft: #fffaeb;
  --radius: 12px;
  --radius-sm: 8px;
  --shadow-sm: 0 1px 2px rgba(16, 24, 40, 0.05);
  --shadow: 0 1px 3px rgba(16, 24, 40, 0.08), 0 1px 2px rgba(16, 24, 40, 0.05);
  --shadow-lg: 0 16px 40px rgba(16, 24, 40, 0.14);
  --sidebar: 232px;
  --topbar: 64px;
  --font: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

[data-org=della] {
  --accent: #1f75e0;
  --accent-soft: #eaf2fd;
}

[data-org="vrd canada"] {
  --accent: #01497c;
  --accent-soft: #e6eff5;
}

[data-org=vezita] {
  --accent: #e8770a;
  --accent-soft: #fef1e2;
}

[data-org=combined] {
  --accent: #5b3fd0;
  --accent-soft: #efebfb;
}

* {
  box-sizing: border-box;
}

html, body, #root {
  height: 100%;
}

body {
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family: var(--font);
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

h1, h2, h3, h4, p {
  margin: 0;
}

h1 {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

h2 {
  font-size: 16px;
  font-weight: 650;
}

h3 {
  font-size: 14px;
  font-weight: 650;
}

button, input, select, textarea {
  font: inherit;
  color: inherit;
}

button {
  cursor: pointer;
}

a {
  color: var(--accent);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

::selection {
  background: var(--accent-soft);
}

.muted {
  color: var(--muted);
}

.num {
  font-variant-numeric: tabular-nums;
}

.row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.grow {
  flex: 1 1;
  min-width: 0;
}

.right {
  margin-left: auto;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.grid {
  display: grid;
  gap: 16px;
}

.grid.cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid.cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid.cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media (max-width: 1100px) {
  .grid.cols-3, .grid.cols-4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 700px) {
  .grid.cols-2, .grid.cols-3, .grid.cols-4 {
    grid-template-columns: 1fr;
  }
}
.shell {
  display: grid;
  grid-template-columns: var(--sidebar) 1fr;
  min-height: 100%;
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border-right: 1px solid var(--border);
  padding: 16px 12px;
  z-index: 30;
}
.sidebar .brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 8px 20px;
  font-weight: 700;
  font-size: 16px;
}
.sidebar .brand img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.sidebar .brand small {
  display: block;
  font-weight: 500;
  color: var(--muted);
  font-size: 11px;
}
.sidebar nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.sidebar .nav-label {
  padding: 14px 10px 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--subtle);
}
.sidebar .nav-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: var(--radius-sm);
  color: var(--muted);
  font-weight: 550;
  text-decoration: none;
}
.sidebar .nav-link svg {
  width: 18px;
  height: 18px;
  flex: none;
}
.sidebar .nav-link:hover {
  background: var(--surface-2);
  color: var(--text);
  text-decoration: none;
}
.sidebar .nav-link.active {
  background: var(--accent-soft);
  color: var(--accent);
}
.sidebar .sidebar-foot {
  margin-top: auto;
  padding: 10px;
  font-size: 12px;
  color: var(--subtle);
}

.main {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  height: var(--topbar);
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 24px;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border);
}
.topbar .burger {
  display: none;
}

.content {
  padding: 24px;
  width: 100%;
  max-width: 1480px;
  margin: 0 auto;
}

.page-head {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.page-head p {
  color: var(--muted);
  margin-top: 2px;
}
.page-head .actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.scrim {
  display: none;
}

.org-select {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 0;
}
.org-select .dot {
  position: absolute;
  left: 12px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--accent);
  pointer-events: none;
}
.org-select select {
  appearance: none;
  height: 38px;
  max-width: 100%;
  padding: 0 36px 0 30px;
  border: 1px solid var(--border-strong);
  border-radius: 10px;
  background: var(--surface);
  font-weight: 650;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
}
.org-select select:hover {
  border-color: var(--accent);
}
.org-select select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.user-menu {
  position: relative;
  margin-left: auto;
}
.user-menu .trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 0;
  background: transparent;
  padding: 4px 6px;
  border-radius: 10px;
}
.user-menu .trigger:hover {
  background: var(--bg);
}
.user-menu .trigger .who {
  text-align: left;
  line-height: 1.2;
}
.user-menu .trigger .who small {
  display: block;
  color: var(--muted);
  font-size: 12px;
}
.user-menu .dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  min-width: 220px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
  padding: 6px;
  z-index: 50;
}
.user-menu .dropdown button {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 9px 10px;
  border-radius: 8px;
}
.user-menu .dropdown button:hover {
  background: var(--bg);
}
.user-menu .dropdown button.danger {
  color: var(--danger);
}
.user-menu .dropdown hr {
  border: 0;
  border-top: 1px solid var(--border);
  margin: 6px 0;
}
.user-menu .dropdown .head {
  padding: 8px 10px;
  font-size: 12px;
  color: var(--muted);
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex: none;
  background: var(--accent-soft);
  color: var(--accent);
  font-weight: 700;
  font-size: 12px;
}

@media (max-width: 900px) {
  .shell {
    grid-template-columns: 1fr;
  }
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    width: 260px;
    transform: translateX(-100%);
    transition: transform 0.2s ease;
    box-shadow: var(--shadow-lg);
  }
  .shell.nav-open .sidebar {
    transform: none;
  }
  .shell.nav-open .scrim {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(16, 24, 40, 0.4);
    z-index: 25;
  }
  .topbar {
    padding: 0 14px;
  }
  .topbar .burger {
    display: inline-flex;
  }
  .topbar .user-menu .who {
    display: none;
  }
  .content {
    padding: 16px;
  }
}
.auth-page {
  --ink: #0b1b3f;
  --soft: #5d6b88;
  --blue-a: #2c9be0;
  --blue-b: #2050a0;
  --lift: 8px 8px 18px rgba(150, 166, 204, 0.42), -8px -8px 18px rgba(255, 255, 255, 0.95);
  position: relative;
  overflow: hidden;
  min-height: 100%;
  display: grid;
  background: linear-gradient(160deg, #f1f5fd 0%, #e3ebf9 55%, #d9e4f6 100%);
  color: var(--ink);
}
.auth-page .shape {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  background: linear-gradient(145deg, #f7faff, #dbe6f8);
  box-shadow: inset 0 0 0 10px rgba(255, 255, 255, 0.55), inset 0 0 0 22px rgba(120, 160, 235, 0.22), 14px 14px 40px rgba(150, 166, 204, 0.3);
}
.auth-page .shape.s1 {
  width: 340px;
  height: 340px;
  left: -150px;
  top: -150px;
}
.auth-page .shape.s2 {
  width: 150px;
  height: 150px;
  right: -64px;
  top: 30%;
  background: linear-gradient(145deg, #dfeafc, #b9d0f6);
}
.auth-page .shape.s3 {
  width: 220px;
  height: 220px;
  left: -100px;
  bottom: 6%;
}
.auth-page .shape.s4 {
  width: 420px;
  height: 420px;
  right: -190px;
  bottom: -190px;
}
.auth-page .form-panel {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 26px;
  padding: 40px 24px;
}
.auth-page form {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: stretch;
  animation: card-in 0.55s cubic-bezier(0.2, 0.7, 0.2, 1) both;
}
.auth-page .logo-tile {
  align-self: center;
  display: grid;
  place-items: center;
  width: 148px;
  height: 148px;
  margin-bottom: 4px;
  border-radius: 42px;
  animation: float 7s ease-in-out infinite;
  background: linear-gradient(145deg, #ffffff, #e4ecfa);
  box-shadow: var(--lift), inset 0 0 0 2px rgba(255, 255, 255, 0.8), inset -6px -6px 14px rgba(150, 166, 204, 0.18);
}
.auth-page .logo-tile img {
  width: 96px;
  height: 96px;
  display: block;
  filter: drop-shadow(0 8px 10px rgba(32, 80, 160, 0.25));
}
.auth-page .form-head {
  text-align: center;
}
.auth-page .form-head .brand-name {
  display: block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: var(--blue-b);
  margin-bottom: 10px;
}
.auth-page .form-head h1 {
  font-size: 36px;
  line-height: 1.1;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: var(--ink);
}
.auth-page .form-head p {
  margin: 10px 0 0;
  font-size: 13px;
  letter-spacing: 0.32em;
  text-transform: lowercase;
  color: var(--soft);
}
.auth-page .field.plain > label {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.auth-page .with-icon {
  position: relative;
}
.auth-page .with-icon .lead {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #33415f;
  display: flex;
  pointer-events: none;
  transition: color 0.2s;
}
.auth-page .with-icon:focus-within .lead {
  color: var(--blue-a);
}
.auth-page .with-icon .input {
  height: 60px;
  padding: 0 56px;
  font-size: 16px;
  color: var(--ink);
  border: 0;
  border-radius: 22px;
  background: linear-gradient(145deg, #f3f7fd, #e8eefa);
  box-shadow: var(--lift), inset 0 0 0 1.5px rgba(255, 255, 255, 0.75);
  transition: box-shadow 0.2s, background 0.2s;
}
.auth-page .with-icon .input::placeholder {
  color: #7d8aa8;
}
.auth-page .with-icon .input:hover {
  box-shadow: 10px 10px 22px rgba(150, 166, 204, 0.46), -8px -8px 18px rgb(255, 255, 255), inset 0 0 0 1.5px rgba(255, 255, 255, 0.75);
}
.auth-page .with-icon .input:focus {
  background: #edf2fb;
  box-shadow: inset 5px 5px 11px rgba(150, 166, 204, 0.4), inset -5px -5px 11px rgba(255, 255, 255, 0.95), 0 0 0 3px rgba(44, 155, 224, 0.35);
}
.auth-page .with-icon .reveal {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: #33415f;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}
.auth-page .with-icon .reveal:hover {
  color: var(--blue-b);
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 3px 3px 8px rgba(150, 166, 204, 0.3);
}
.auth-page .with-icon .reveal:focus-visible {
  outline: 2px solid var(--blue-a);
}
.auth-page .alert {
  border-radius: 18px;
  padding: 12px 16px;
  font-weight: 500;
  text-align: center;
  background: #fff1f0;
  border: 0;
  box-shadow: var(--lift);
  animation: card-in 0.25s ease both;
}
.auth-page .signin {
  position: relative;
  height: 62px;
  margin-top: 6px;
  border: 0;
  border-radius: 31px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #fff;
  background: linear-gradient(135deg, var(--blue-a) 0%, #2a6fd0 50%, var(--blue-b) 100%);
  box-shadow: 0 16px 30px -8px rgba(32, 80, 160, 0.65), inset 0 2px 0 rgba(255, 255, 255, 0.35), inset 0 -3px 6px rgba(10, 30, 90, 0.25);
  transition: transform 0.18s, box-shadow 0.18s;
}
.auth-page .signin .spinner {
  border-color: rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
}
.auth-page .signin .go {
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
  transition: transform 0.18s, background 0.18s;
}
.auth-page .signin:hover:not(:disabled) {
  filter: none;
  background: linear-gradient(135deg, #3aa6ea 0%, #2a6fd0 50%, var(--blue-b) 100%);
  transform: translateY(-2px);
  box-shadow: 0 20px 34px -8px rgba(32, 80, 160, 0.75), inset 0 2px 0 rgba(255, 255, 255, 0.35), inset 0 -3px 6px rgba(10, 30, 90, 0.25);
}
.auth-page .signin:hover:not(:disabled) .go {
  transform: translateY(-50%) translateX(3px);
  background: rgba(255, 255, 255, 0.32);
}
.auth-page .signin:active:not(:disabled) {
  transform: translateY(0);
}
.auth-page .signin:focus-visible {
  outline: 3px solid rgba(44, 155, 224, 0.5);
  outline-offset: 3px;
}
.auth-page .signin:disabled {
  opacity: 0.55;
  box-shadow: 0 8px 16px -8px rgba(32, 80, 160, 0.4);
}
.auth-page .help {
  text-align: center;
  font-size: 13px;
  color: var(--soft);
  margin: 4px 0 0;
}
.auth-page .tagline {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.26em;
  text-transform: uppercase;
  color: #5d6b88;
}
.auth-page .tagline i {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--blue-a);
}

@media (min-width: 700px) {
  .auth-page .form-panel form {
    max-width: 460px;
    padding: 48px 48px 40px;
    border-radius: 44px;
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.78), rgba(232, 239, 251, 0.78));
    box-shadow: 18px 18px 44px rgba(150, 166, 204, 0.4), -14px -14px 34px rgba(255, 255, 255, 0.95), inset 0 0 0 2px rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(8px);
  }
  .auth-page .shape.s1 {
    width: 520px;
    height: 520px;
    left: -220px;
    top: -220px;
  }
  .auth-page .shape.s2 {
    width: 220px;
    height: 220px;
    right: -90px;
    top: 28%;
  }
  .auth-page .shape.s3 {
    width: 320px;
    height: 320px;
    left: -140px;
    bottom: 4%;
  }
  .auth-page .shape.s4 {
    width: 620px;
    height: 620px;
    right: -270px;
    bottom: -270px;
  }
}
@media (max-height: 760px) {
  .auth-page .logo-tile {
    width: 112px;
    height: 112px;
    border-radius: 32px;
  }
  .auth-page .logo-tile img {
    width: 72px;
    height: 72px;
  }
  .auth-page .form-head h1 {
    font-size: 30px;
  }
  .auth-page .form-panel {
    gap: 18px;
    padding: 24px;
  }
  .auth-page form {
    gap: 14px;
  }
}
@media (min-width: 700px) and (max-height: 760px) {
  .auth-page .form-panel form {
    padding: 32px 44px 28px;
  }
}
.auth-page .with-icon .input.invalid, .auth-page .with-icon .input.invalid:focus {
  box-shadow: var(--lift), 0 0 0 3px rgba(240, 68, 56, 0.4);
}

.auth-page .field .err {
  text-align: left;
  padding-left: 6px;
  font-size: 13px;
}

.auth-page ::selection {
  background: #2c8de0;
  color: #fff;
}

.auth-page .input:-webkit-autofill, .auth-page .input:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--ink);
  caret-color: var(--ink);
  box-shadow: var(--lift), inset 0 0 0 100px #d4e6fb;
  -webkit-transition: background-color 9999s;
  transition: background-color 9999s;
}

@media (max-width: 420px) {
  .auth-page .tagline {
    gap: 7px;
    font-size: 10px;
    letter-spacing: 0.14em;
  }
}
@keyframes card-in {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .auth-page * {
    animation: none !important;
    transition: none !important;
  }
}
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 38px;
  padding: 0 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: var(--surface);
  font-weight: 600;
  box-shadow: var(--shadow-sm);
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}
.btn svg {
  width: 16px;
  height: 16px;
}
.btn:hover:not(:disabled) {
  background: var(--surface-2);
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn.primary {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--accent-ink);
}
.btn.primary:hover:not(:disabled) {
  filter: brightness(0.94);
  background: var(--accent);
}
.btn.danger {
  color: var(--danger);
  border-color: #fda29b;
}
.btn.danger:hover:not(:disabled) {
  background: var(--danger-soft);
}
.btn.ghost {
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.btn.ghost:hover:not(:disabled) {
  background: var(--bg);
}
.btn.sm {
  height: 30px;
  padding: 0 10px;
  font-size: 13px;
}
.btn.icon {
  width: 38px;
  padding: 0;
}
.btn.icon.sm {
  width: 30px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.field > label, .field .label {
  font-size: 13px;
  font-weight: 600;
  color: #344054;
}
.field .hint {
  font-size: 12px;
  color: var(--muted);
}
.field .err {
  font-size: 12px;
  color: var(--danger);
}

.input, .select, .textarea {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.input::placeholder, .select::placeholder, .textarea::placeholder {
  color: var(--subtle);
}
.input:focus, .select:focus, .textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}
.input:disabled, .select:disabled, .textarea:disabled {
  background: var(--bg);
  color: var(--muted);
}
.input.invalid, .select.invalid, .textarea.invalid {
  border-color: var(--danger);
}
.input.invalid:focus, .select.invalid:focus, .textarea.invalid:focus {
  box-shadow: 0 0 0 3px var(--danger-soft);
}

.select {
  appearance: none;
  padding-right: 32px;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
}

.textarea {
  height: auto;
  min-height: 84px;
  padding: 10px 12px;
  resize: vertical;
}

.search {
  position: relative;
}
.search svg {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  color: var(--subtle);
}
.search .input {
  padding-left: 34px;
}

.check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.check input {
  width: 16px;
  height: 16px;
  accent-color: var(--accent);
}

.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
.card .card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
}
.card .card-head p {
  color: var(--muted);
  font-size: 13px;
}
.card .card-body {
  padding: 20px;
}
.card.flush .card-body {
  padding: 0;
}

.stat {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.stat .label {
  color: var(--muted);
  font-weight: 550;
  font-size: 13px;
}
.stat .value {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}
.stat .sub {
  color: var(--muted);
  font-size: 12px;
}
.stat.clickable {
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s;
}
.stat.clickable:hover {
  border-color: var(--accent);
  box-shadow: var(--shadow);
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: var(--bg);
  color: #344054;
  white-space: nowrap;
}
.badge.success {
  background: var(--success-soft);
  color: #027a48;
}
.badge.danger {
  background: var(--danger-soft);
  color: #b42318;
}
.badge.warning {
  background: var(--warning-soft);
  color: #b54708;
}
.badge.accent {
  background: var(--accent-soft);
  color: var(--accent);
}

.chip {
  border: 1px solid var(--border-strong);
  background: var(--surface);
  border-radius: 999px;
  padding: 5px 12px;
  font-weight: 600;
  font-size: 13px;
  color: var(--muted);
}
.chip:hover {
  color: var(--text);
}
.chip.on {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent);
}

.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--border);
  overflow-x: auto;
}
.tabs button {
  border: 0;
  background: transparent;
  padding: 10px 14px;
  font-weight: 600;
  color: var(--muted);
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  white-space: nowrap;
}
.tabs button:hover {
  color: var(--text);
}
.tabs button.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.seg {
  display: inline-flex;
  padding: 3px;
  background: var(--bg);
  border-radius: 9px;
}
.seg button {
  border: 0;
  background: transparent;
  padding: 6px 12px;
  border-radius: 7px;
  font-weight: 600;
  font-size: 13px;
  color: var(--muted);
}
.seg button.on {
  background: var(--surface);
  color: var(--text);
  box-shadow: var(--shadow);
}

.progress {
  height: 8px;
  background: var(--bg);
  border-radius: 999px;
  overflow: hidden;
}
.progress > i {
  display: block;
  height: 100%;
  background: var(--accent);
  border-radius: 999px;
  transition: width 0.4s;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
}
.toolbar .search {
  flex: 1 1 240px;
  max-width: 360px;
}
.toolbar .select {
  width: auto;
  min-width: 140px;
}

.table-wrap {
  overflow: auto;
  position: relative;
}

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 640px;
}
.table th {
  position: sticky;
  top: 0;
  background: var(--surface-2);
  text-align: left;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.table th.sortable {
  cursor: pointer;
}
.table th.sortable:hover {
  color: var(--text);
}
.table th .arrow {
  margin-left: 4px;
  color: var(--accent);
}
.table td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}
.table tbody tr {
  transition: background 0.1s;
}
.table tbody tr:last-child td {
  border-bottom: 0;
}
.table tbody tr.clickable {
  cursor: pointer;
}
.table tbody tr:hover {
  background: var(--surface-2);
}
.table .r {
  text-align: right;
}
.table .c {
  text-align: center;
}

.pager {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 20px;
  border-top: 1px solid var(--border);
  font-size: 13px;
  color: var(--muted);
}
.pager .pages {
  display: flex;
  gap: 4px;
  margin-left: auto;
  align-items: center;
}
.pager .pages button {
  min-width: 32px;
  height: 32px;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 8px;
  font-weight: 600;
  color: var(--muted);
}
.pager .pages button:hover:not(:disabled) {
  background: var(--bg);
}
.pager .pages button.on {
  background: var(--accent-soft);
  color: var(--accent);
}
.pager .pages button:disabled {
  opacity: 0.4;
  cursor: default;
}
.pager .select {
  height: 32px;
  min-width: 0;
  width: auto;
}

.skeleton {
  background: linear-gradient(90deg, #eef1f6 25%, #f6f8fb 37%, #eef1f6 63%);
  background-size: 400% 100%;
  animation: shimmer 1.3s ease infinite;
  border-radius: 6px;
  height: 14px;
}

@keyframes shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.empty {
  padding: 48px 20px;
  text-align: center;
  color: var(--muted);
}
.empty svg {
  width: 36px;
  height: 36px;
  color: var(--subtle);
  margin-bottom: 8px;
}
.empty strong {
  display: block;
  color: var(--text);
  font-size: 15px;
}

.alert {
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  font-size: 13px;
  background: var(--danger-soft);
  color: #b42318;
  border: 1px solid #fecdca;
}
.alert.info {
  background: var(--accent-soft);
  color: var(--accent);
  border-color: transparent;
}
.alert.warning {
  background: var(--warning-soft);
  color: #b54708;
  border-color: #fedf89;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid var(--border-strong);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(16, 24, 40, 0.45);
  z-index: 60;
  display: flex;
  justify-content: flex-end;
  animation: fade 0.15s;
}

.drawer {
  width: min(720px, 100%);
  height: 100%;
  background: var(--surface);
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
  animation: slide 0.2s ease;
}
.drawer.narrow {
  width: min(520px, 100%);
}
.drawer.wide {
  width: min(1080px, 100%);
}
.drawer header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 24px;
  border-bottom: 1px solid var(--border);
}
.drawer header h2 {
  font-size: 18px;
}
.drawer .body {
  flex: 1 1;
  overflow: auto;
  padding: 24px;
}
.drawer footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 14px 24px;
  border-top: 1px solid var(--border);
  background: var(--surface-2);
}

.overlay.center {
  justify-content: center;
  align-items: center;
}
.overlay.center .drawer {
  height: auto;
  max-height: 90vh;
  width: min(460px, 94%);
  border-radius: var(--radius);
  animation: pop 0.15s ease;
}

@keyframes fade {
  from {
    opacity: 0;
  }
}
@keyframes slide {
  from {
    transform: translateX(32px);
    opacity: 0;
  }
}
@keyframes pop {
  from {
    transform: scale(0.96);
    opacity: 0;
  }
}
.toasts {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.toasts .toast {
  min-width: 260px;
  max-width: 380px;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  background: #101828;
  color: #fff;
  box-shadow: var(--shadow-lg);
  animation: slide 0.2s ease;
}
.toasts .toast.error {
  background: #b42318;
}
.toasts .toast.success {
  background: #067647;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.form-grid .full {
  grid-column: 1/-1;
}

@media (max-width: 600px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}
.chart-box {
  height: 320px;
  position: relative;
}

.multi {
  position: relative;
  min-width: 0;
}
.multi .multi-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  cursor: pointer;
  color: var(--muted);
}
.multi .multi-trigger.has {
  color: var(--text);
  border-color: var(--accent);
}
.multi .multi-trigger .grow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.multi .multi-trigger .count {
  background: var(--accent);
  color: var(--accent-ink);
  border-radius: 999px;
  padding: 0 7px;
  font-size: 11px;
  font-weight: 700;
}
.multi .multi-trigger svg {
  transform: rotate(90deg);
  color: var(--subtle);
  flex: none;
}
.multi .multi-panel {
  position: absolute;
  z-index: 40;
  top: calc(100% + 6px);
  left: 0;
  min-width: 100%;
  width: max-content;
  max-width: 360px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.multi .multi-actions {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
  font-size: 12px;
}
.multi .multi-actions .link:disabled {
  opacity: 0.4;
  cursor: default;
  text-decoration: none;
}
.multi .multi-list {
  max-height: 260px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.multi .multi-list .check {
  padding: 7px 8px;
  border-radius: 6px;
}
.multi .multi-list .check:hover {
  background: var(--bg);
}

.link {
  background: none;
  border: 0;
  padding: 0;
  color: var(--accent);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
}

.purpose {
  background: var(--accent-soft, #eff6ff);
  border: 1px solid var(--border, #d0d5dd);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 16px;
}
.purpose summary {
  cursor: pointer;
  font-weight: 600;
}
.purpose p {
  margin: 6px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/_tokens.scss","webpack://./src/styles/index.scss","webpack://./src/styles/_layout.scss","webpack://./src/styles/_components.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EAEA,iBAAA;EACA,sBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EAEA,cAAA;EACA,gBAAA;EACA,6CAAA;EACA,4EAAA;EACA,+CAAA;EACA,gBAAA;EACA,cAAA;EACA,2GAAA;ACFF;;ADMA;EAAqB,iBAAA;EAAmB,sBAAA;ACDxC;;ADEA;EAA0B,iBAAA;EAAmB,sBAAA;ACG7C;;ADFA;EAAsB,iBAAA;EAAmB,sBAAA;ACOzC;;ADNA;EAAwB,iBAAA;EAAmB,sBAAA;ACW3C;;ADTA;EAAI,sBAAA;ACaJ;;ADZA;EAAoB,YAAA;ACgBpB;;ADfA;EACE,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;ACkBF;;ADhBA;EAAoB,SAAA;ACoBpB;;ADnBA;EAAK,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;ACyBxC;;ADxBA;EAAK,eAAA;EAAiB,gBAAA;AC6BtB;;AD5BA;EAAK,eAAA;EAAiB,gBAAA;ACiCtB;;ADhCA;EAAkC,aAAA;EAAe,cAAA;ACqCjD;;ADpCA;EAAS,eAAA;ACwCT;;ADvCA;EAAI,oBAAA;EAAsB,qBAAA;AC4C1B;;AD3CA;EAAU,0BAAA;AC+CV;;AD9CA;EAAiB,gCAAA;EAAkC,mBAAA;ACmDnD;;ADlDA;EAAc,8BAAA;ACsDd;;ADrDA;EAAS,mBAAA;ACyDT;;ADxDA;EAAO,kCAAA;AC4DP;;AD3DA;EAAO,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;ACkEtD;;ADjEA;EAAQ,SAAA;EAAS,YAAA;ACsEjB;;ADrEA;EAAS,iBAAA;ACyET;;ADxEA;EAAS,aAAA;EAAe,sBAAA;EAAwB,SAAA;AC8EhD;;AD7EA;EAAQ,aAAA;EAAe,SAAA;ACkFvB;;ADjFA;EAAe,gDAAA;ACqFf;;ADpFA;EAAe,gDAAA;ACwFf;;ADvFA;EAAe,gDAAA;AC2Ff;;AD1FA;EAA6B;IAA6B,gDAAA;EC+FxD;AACF;AD/FA;EAA4B;IAA2C,0BAAA;ECmGrE;AACF;ACzKA;EAAS,aAAA;EAAe,yCAAA;EAA2C,gBAAA;AD8KnE;;AC7KA;EACE,gBAAA;EAAkB,MAAA;EAAQ,aAAA;EAAe,aAAA;EAAe,sBAAA;EACxD,0BAAA;EAA4B,qCAAA;EAAuC,kBAAA;EAAoB,WAAA;ADuLzF;ACtLE;EAAS,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,qBAAA;EAAuB,gBAAA;EAAkB,eAAA;AD8LnG;AC7LI;EAAM,WAAA;EAAa,YAAA;EAAc,mBAAA;ADkMrC;AClM4D;EAAQ,cAAA;EAAgB,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;ADwM3H;ACvME;EAAM,aAAA;EAAe,sBAAA;EAAwB,QAAA;AD4M/C;AC3ME;EAAa,sBAAA;EAAwB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,oBAAA;ADmN7H;AClNE;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,iBAAA;EAAmB,+BAAA;EAClE,mBAAA;EAAqB,gBAAA;EAAkB,qBAAA;AD0N3C;ACzNI;EAAM,WAAA;EAAa,YAAA;EAAc,UAAA;AD8NrC;AC7NI;EAAU,4BAAA;EAA8B,kBAAA;EAAoB,qBAAA;ADkOhE;ACjOI;EAAW,8BAAA;EAAgC,oBAAA;ADqO/C;ACnOE;EAAgB,gBAAA;EAAkB,aAAA;EAAe,eAAA;EAAiB,oBAAA;ADyOpE;;ACvOA;EAAQ,YAAA;EAAc,aAAA;EAAe,sBAAA;AD6OrC;;AC5OA;EACE,gBAAA;EAAkB,MAAA;EAAQ,WAAA;EAAa,qBAAA;EAAuB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAClG,eAAA;EAAiB,qCAAA;EAAuC,2BAAA;EAA6B,sCAAA;ADwPvF;ACvPE;EAAU,aAAA;AD0PZ;;ACxPA;EAAW,aAAA;EAAe,WAAA;EAAa,iBAAA;EAAmB,cAAA;AD+P1D;;AC9PA;EAAa,aAAA;EAAe,qBAAA;EAAuB,SAAA;EAAW,eAAA;EAAiB,mBAAA;ADsQ/E;ACrQE;EAAI,mBAAA;EAAqB,eAAA;ADyQ3B;ACzQ8C;EAAW,iBAAA;EAAmB,aAAA;EAAe,QAAA;EAAU,eAAA;AD+QrG;;AC9QA;EAAS,aAAA;ADkRT;;AChRA;EAAc,kBAAA;EAAoB,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;ADuR7E;ACtRE;EAAO,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,yBAAA;EAA2B,oBAAA;AD+RnH;AC9RE;EAAS,gBAAA;EAAkB,YAAA;EAAc,eAAA;EAAiB,sBAAA;EAAwB,sCAAA;EAAwC,mBAAA;EACxH,0BAAA;EAA4B,gBAAA;EAAkB,4BAAA;EAA8B,eAAA;EAC5E,yDAAA;EACA,4BAAA;EAA8B,sCAAA;AD0SlC;ACzSI;EAAU,2BAAA;AD4Sd;AC5S6C;EAAU,aAAA;EAAe,2BAAA;EAA6B,wCAAA;ADiTnG;;AC/SA;EAAW,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,gBAAA;EAAkB,mBAAA;EAAqB,mBAAA;ADwT/F;;ACvTA;EAAa,kBAAA;EAAoB,iBAAA;AD4TjC;AC3TE;EAAW,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,SAAA;EAAW,uBAAA;EAAyB,gBAAA;EAAkB,mBAAA;ADoUlH;ACnUI;EAAU,qBAAA;ADsUd;ACtUuC;EAAO,gBAAA;EAAkB,gBAAA;AD0UhE;AC1UkF;EAAQ,cAAA;EAAgB,mBAAA;EAAqB,eAAA;AD+U/H;AC9UE;EAAY,kBAAA;EAAoB,QAAA;EAAU,qBAAA;EAAuB,gBAAA;EAAkB,0BAAA;EAA4B,+BAAA;EAC7G,4BAAA;EAA8B,4BAAA;EAA8B,YAAA;EAAc,WAAA;ADyV9E;ACxVI;EAAS,cAAA;EAAgB,WAAA;EAAa,gBAAA;EAAkB,SAAA;EAAW,uBAAA;EAAyB,iBAAA;EAAmB,kBAAA;ADiWnH;AChWM;EAAU,qBAAA;ADmWhB;ACnWyC;EAAW,oBAAA;ADsWpD;ACrWI;EAAK,SAAA;EAAW,mCAAA;EAAqC,aAAA;AD0WzD;AC1W0E;EAAQ,iBAAA;EAAmB,eAAA;EAAiB,mBAAA;AD+WtH;;AC7WA;EAAU,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,UAAA;EAC3F,8BAAA;EAAgC,oBAAA;EAAsB,gBAAA;EAAkB,eAAA;ADyX1E;;ACvXA;EACE;IAAS,0BAAA;ED2XT;EC1XA;IAAW,eAAA;IAAiB,OAAA;IAAS,MAAA;IAAQ,YAAA;IAAc,4BAAA;IAA8B,+BAAA;IAAiC,4BAAA;EDmY1H;EClYA;IAA2B,eAAA;EDqY3B;ECpYA;IAAyB,cAAA;IAAgB,eAAA;IAAiB,QAAA;IAAU,iCAAA;IAAmC,WAAA;ED2YvG;EC1YA;IAAU,eAAA;ED6YV;EC7Y2B;IAAU,oBAAA;EDgZrC;EChZ6D;IAAkB,aAAA;EDmZ/E;EClZA;IAAW,aAAA;EDqZX;AACF;AClZA;EAAa,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,iBAAA;EAAmB,wFAAA;EAClF,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;EAAkB,aAAA;EAAe,0EAAA;EAA4E,iBAAA;AD8ZrJ;AC3ZE;EAAS,kBAAA;EAAoB,kBAAA;EAAoB,oBAAA;EAAsB,qDAAA;EAAuD,2IAAA;ADkahI;ACjaI;EAAO,YAAA;EAAc,aAAA;EAAe,YAAA;EAAc,WAAA;ADuatD;ACtaI;EAAO,YAAA;EAAc,aAAA;EAAe,YAAA;EAAc,QAAA;EAAU,qDAAA;AD6ahE;AC5aI;EAAO,YAAA;EAAc,aAAA;EAAe,YAAA;EAAc,UAAA;ADkbtD;ACjbI;EAAO,YAAA;EAAc,aAAA;EAAe,aAAA;EAAe,cAAA;ADubvD;ACrbE;EAAc,kBAAA;EAAoB,UAAA;EAAY,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,SAAA;EAAW,kBAAA;AD+bhJ;AC7bE;EAAO,WAAA;EAAa,gBAAA;EAAkB,aAAA;EAAe,sBAAA;EAAwB,SAAA;EAAW,oBAAA;EAAsB,4DAAA;ADschH;ACpcE;EAAa,kBAAA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,YAAA;EAAc,aAAA;EAAe,kBAAA;EAAoB,mBAAA;EAAqB,wCAAA;EACzI,qDAAA;EAAuD,iHAAA;AD+c3D;AC9cI;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,uDAAA;ADodrD;ACldE;EAAa,kBAAA;ADqdf;ACrdmC;EAAc,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAwB,yBAAA;EAA2B,oBAAA;EAAsB,mBAAA;AD8d7K;AC7dI;EAAK,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAyB,gBAAA;EAAkB,iBAAA;ADoevF;ACneI;EAAI,gBAAA;EAAkB,eAAA;EAAiB,sBAAA;EAAwB,yBAAA;EAA2B,kBAAA;AD0e9F;ACxeE;EAAuB,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,gBAAA;EAAkB,mBAAA;EAAqB,mBAAA;ADgf7G;AC9eE;EAAa,kBAAA;ADiff;AChfI;EAAQ,kBAAA;EAAoB,UAAA;EAAY,QAAA;EAAU,2BAAA;EAA6B,cAAA;EAAgB,aAAA;EAAe,oBAAA;EAAsB,sBAAA;AD0fxI;ACzfI;EAAuB,oBAAA;AD4f3B;AC3fI;EAAS,YAAA;EAAc,eAAA;EAAiB,eAAA;EAAiB,iBAAA;EAAmB,SAAA;EAAW,mBAAA;EAAqB,qDAAA;EAC1G,oEAAA;EAAsE,4CAAA;ADqgB5E;ACpgBM;EAAiB,cAAA;ADugBvB;ACvgByC;EAAU,oIAAA;AD0gBnD;ACzgBM;EAAU,mBAAA;EAAqB,2IAAA;AD6gBrC;AC5gBI;EAAU,kBAAA;EAAoB,WAAA;EAAa,QAAA;EAAU,2BAAA;EAA6B,WAAA;EAAa,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,mBAAA;EAC1J,uBAAA;EAAyB,cAAA;EAAgB,eAAA;EAAiB,wDAAA;AD2hBhE;AC1hBM;EAAU,oBAAA;EAAsB,oCAAA;EAAsC,gDAAA;AD+hB5E;AC/hBgI;EAAkB,gCAAA;ADkiBlJ;AChiBE;EAAS,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,SAAA;EAAW,uBAAA;EAAyB,kCAAA;AD0iBnJ;ACxiBE;EAAU,kBAAA;EAAoB,YAAA;EAAc,eAAA;EAAiB,SAAA;EAAW,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAwB,WAAA;EACtJ,sFAAA;EAAwF,sIAAA;EACxF,6CAAA;ADojBJ;ACpjBmD;EAAW,sCAAA;EAAwC,sBAAA;ADwjBtG;ACvjBI;EAAM,kBAAA;EAAoB,UAAA;EAAY,QAAA;EAAU,2BAAA;EAA6B,WAAA;EAAa,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,kBAAA;EAAoB,qCAAA;EAC9J,kDAAA;EAAoD,6CAAA;ADokB1D;ACnkBI;EAAyB,YAAA;EAAc,gFAAA;EAAkF,2BAAA;EAA6B,sIAAA;ADykB1J;ACxkBM;EAAM,2CAAA;EAA6C,qCAAA;AD4kBzD;AC3kBI;EAA0B,wBAAA;AD8kB9B;AC9kB0D;EAAkB,0CAAA;EAA4C,mBAAA;ADklBxH;ACllB+I;EAAa,aAAA;EAAe,kDAAA;ADslB3K;ACplBE;EAAQ,kBAAA;EAAoB,eAAA;EAAiB,kBAAA;EAAoB,eAAA;AD0lBnE;ACzlBE;EAAW,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,SAAA;EAAW,SAAA;EAAW,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAwB,yBAAA;EAA2B,cAAA;ADsmBvM;ACrmBI;EAAI,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,yBAAA;AD2mBrD;;ACxmBA;EACE;IAA8B,gBAAA;IAAkB,uBAAA;IAAyB,mBAAA;IAAqB,yFAAA;IAC5F,yIAAA;IAA2I,0BAAA;EDgnB7I;EC/mBoB;IAAO,YAAA;IAAc,aAAA;IAAe,YAAA;IAAc,WAAA;EDqnBtE;ECrnBqF;IAAO,YAAA;IAAc,aAAA;IAAe,YAAA;IAAc,QAAA;ED2nBvI;EC3nBmJ;IAAO,YAAA;IAAc,aAAA;IAAe,YAAA;IAAc,UAAA;EDioBrM;ECjoBmN;IAAO,YAAA;IAAc,aAAA;IAAe,aAAA;IAAe,cAAA;EDuoBtQ;AACF;ACtoBA;EAA0C;IAAa,YAAA;IAAc,aAAA;IAAe,mBAAA;ED4oBlF;EC5oBuG;IAAM,WAAA;IAAa,YAAA;EDgpB1H;EChpB4I;IAAgB,eAAA;EDmpB5J;ECnpB+K;IAAc,SAAA;IAAW,aAAA;EDupBxM;ECvpByN;IAAO,SAAA;ED0pBhO;AACF;AC1pBA;EAAoD;IAA8B,uBAAA;ED8pBhF;AACF;AC5pBA;EAAmF,yDAAA;AD+pBnF;;AC9pBA;EAAyB,gBAAA;EAAkB,iBAAA;EAAmB,eAAA;ADoqB9D;;AClqBA;EAAyB,mBAAA;EAAqB,WAAA;ADuqB9C;;ACtqBA;EAA+E,mCAAA;EAAqC,uBAAA;EAAyB,kDAAA;EAAoD,0CAAA;EAAA,kCAAA;AD6qBjM;;AC5qBA;EAA4B;IAAsB,QAAA;IAAU,eAAA;IAAiB,sBAAA;EDmrB3E;AACF;AClrBA;EAAqB;IAAO,UAAA;IAAY,2BAAA;EDurBtC;ECvrBqE;IAAK,UAAA;IAAY,eAAA;ED2rBtF;AACF;AC3rBA;EAAmB;IAAW,wBAAA;ED+rB5B;EC/rBwD;IAAM,2BAAA;EDksB9D;AACF;AClsBA;EAA0C;IAAe,0BAAA;IAA4B,2BAAA;EDusBnF;AACF;AEx0BA;EAAO,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,YAAA;EAAc,eAAA;EAAiB,+BAAA;EAClH,sCAAA;EAAwC,0BAAA;EAA4B,gBAAA;EAAkB,4BAAA;EAA8B,mBAAA;EAAqB,gDAAA;AFs1B3I;AEr1BE;EAAM,WAAA;EAAa,YAAA;AFy1BrB;AEz1BqC;EAAyB,4BAAA;AF41B9D;AE31BE;EAAa,aAAA;EAAe,mBAAA;AF+1B9B;AE91BE;EAAY,yBAAA;EAA2B,2BAAA;EAA6B,wBAAA;AFm2BtE;AEn2BgG;EAAyB,wBAAA;EAA0B,yBAAA;AFu2BnJ;AEt2BE;EAAW,oBAAA;EAAsB,qBAAA;AF02BnC;AE12B0D;EAAyB,8BAAA;AF62BnF;AE52BE;EAAU,yBAAA;EAA2B,uBAAA;EAAyB,gBAAA;AFi3BhE;AEj3BkF;EAAyB,qBAAA;AFo3B3G;AEn3BE;EAAO,YAAA;EAAc,eAAA;EAAiB,eAAA;AFw3BxC;AEx3B2D;EAAS,WAAA;EAAa,UAAA;AF43BjF;AE53B6F;EAAO,WAAA;AF+3BpG;;AE73BA;EAAS,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,YAAA;AFo4B1D;AEn4BE;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AFw4BvD;AEx4ByE;EAAQ,eAAA;EAAiB,mBAAA;AF44BlG;AE54ByH;EAAO,eAAA;EAAiB,oBAAA;AFg5BjJ;;AE/4BA;EAA6B,WAAA;EAAa,YAAA;EAAc,eAAA;EAAiB,0BAAA;EAA4B,sCAAA;EAAwC,+BAAA;EAC3I,4BAAA;EAA8B,gDAAA;AFy5BhC;AEx5BE;EAAiB,oBAAA;AF25BnB;AE35B2C;EAAU,aAAA;EAAe,2BAAA;EAA6B,wCAAA;AFg6BjG;AE/5BE;EAAa,qBAAA;EAAuB,mBAAA;AFm6BtC;AEn6B6D;EAAY,2BAAA;AFs6BzE;AEt6BsG;EAAU,wCAAA;AFy6BhH;;AEx6BA;EAAU,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;EAC/C,yDAAA;EACA,4BAAA;EAA8B,sCAAA;AF+6BhC;;AE96BA;EAAY,YAAA;EAAc,gBAAA;EAAkB,kBAAA;EAAoB,gBAAA;AFq7BhE;;AEp7BA;EAAU,kBAAA;AFw7BV;AEx7B8B;EAAM,kBAAA;EAAoB,UAAA;EAAY,QAAA;EAAU,2BAAA;EAA6B,WAAA;EAAa,oBAAA;AFg8BxH;AEh8BgJ;EAAS,kBAAA;AFm8BzJ;;AEl8BA;EAAS,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,yBAAA;UAAA,iBAAA;AF08B/E;AE18BkG;EAAQ,WAAA;EAAa,YAAA;EAAc,2BAAA;AF+8BrI;;AE78BA;EAAQ,0BAAA;EAA4B,+BAAA;EAAiC,4BAAA;EAA8B,4BAAA;AFo9BnG;AEn9BE;EAAa,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,kBAAA;EAAoB,sCAAA;AF29BnG;AE39B2I;EAAI,mBAAA;EAAqB,eAAA;AF+9BpK;AE99BE;EAAa,aAAA;AFi+Bf;AEj+BgC;EAAqB,UAAA;AFo+BrD;;AEn+BA;EAAQ,kBAAA;EAAoB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AF0+BnE;AE1+B6E;EAAS,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;AF++B7H;AE9+BE;EAAS,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAyB,kCAAA;AFo/BvE;AEp/B6G;EAAO,mBAAA;EAAqB,eAAA;AFw/BzI;AEv/BE;EAAc,eAAA;EAAiB,gDAAA;AF2/BjC;AE3/BmF;EAAU,2BAAA;EAA6B,yBAAA;AF+/B1H;;AE9/BA;EAAS,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,oBAAA;EAAsB,eAAA;EAAiB,gBAAA;EAAkB,qBAAA;EAAuB,cAAA;EAAgB,mBAAA;AF2gChL;AE1gCE;EAAY,+BAAA;EAAiC,cAAA;AF8gC/C;AE9gCiE;EAAW,8BAAA;EAAgC,cAAA;AFkhC5G;AEjhCE;EAAY,+BAAA;EAAiC,cAAA;AFqhC/C;AErhCiE;EAAW,8BAAA;EAAgC,oBAAA;AFyhC5G;;AExhCA;EAAQ,sCAAA;EAAwC,0BAAA;EAA4B,oBAAA;EAAsB,iBAAA;EAAmB,gBAAA;EAAkB,eAAA;EAAiB,mBAAA;AFkiCxJ;AEjiCE;EAAU,kBAAA;AFoiCZ;AEpiCkC;EAAO,8BAAA;EAAgC,2BAAA;EAA6B,oBAAA;AFyiCtG;;AExiCA;EAAQ,aAAA;EAAe,QAAA;EAAU,sCAAA;EAAwC,gBAAA;AF+iCzE;AE9iCE;EAAS,SAAA;EAAW,uBAAA;EAAyB,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;EAAqB,oCAAA;EAAsC,mBAAA;EAAqB,mBAAA;AFwjCrK;AEvjCI;EAAU,kBAAA;AF0jCd;AE1jCoC;EAAW,oBAAA;EAAsB,kCAAA;AF8jCrE;;AE7jCA;EAAO,oBAAA;EAAsB,YAAA;EAAc,qBAAA;EAAuB,kBAAA;AFokClE;AEnkCE;EAAS,SAAA;EAAW,uBAAA;EAAyB,iBAAA;EAAmB,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;EAAiB,mBAAA;AF4kCzH;AE3kCI;EAAO,0BAAA;EAA4B,kBAAA;EAAoB,yBAAA;AFglC3D;;AE/kCA;EAAY,WAAA;EAAa,qBAAA;EAAuB,oBAAA;EAAsB,gBAAA;AFslCtE;AEtlCwF;EAAM,cAAA;EAAgB,YAAA;EAAc,yBAAA;EAA2B,oBAAA;EAAsB,sBAAA;AF6lC7K;;AE3lCA;EAAW,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,kBAAA;EAAoB,sCAAA;AFomC/F;AEnmCE;EAAU,eAAA;EAAiB,gBAAA;AFumC7B;AEvmCiD;EAAU,WAAA;EAAa,gBAAA;AF2mCxE;;AE1mCA;EAAc,cAAA;EAAgB,kBAAA;AF+mC9B;;AE9mCA;EAAS,WAAA;EAAa,yBAAA;EAA2B,iBAAA;EAAmB,gBAAA;AFqnCpE;AEpnCE;EAAK,gBAAA;EAAkB,MAAA;EAAQ,4BAAA;EAA8B,gBAAA;EAAkB,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;EACpI,yBAAA;EAA2B,sBAAA;EAAwB,sCAAA;EAAwC,mBAAA;EAAqB,yBAAA;UAAA,iBAAA;AFkoCpH;AEjoCI;EAAa,eAAA;AFooCjB;AEpoCkC;EAAU,kBAAA;AFuoC5C;AEvoCoE;EAAS,gBAAA;EAAkB,oBAAA;AF2oC/F;AE1oCE;EAAK,kBAAA;EAAoB,sCAAA;EAAwC,sBAAA;AF+oCnE;AE9oCE;EAAW,2BAAA;AFipCb;AEjpC0C;EAAkB,gBAAA;AFopC5D;AEppCgF;EAAc,eAAA;AFupC9F;AEvpCiH;EAAU,4BAAA;AF0pC3H;AEzpCE;EAAK,iBAAA;AF4pCP;AE5pC4B;EAAK,kBAAA;AF+pCjC;;AE9pCA;EAAS,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,kBAAA;EAAoB,mCAAA;EAAqC,eAAA;EAAiB,mBAAA;AFyqCnJ;AExqCE;EAAS,aAAA;EAAe,QAAA;EAAU,iBAAA;EAAmB,mBAAA;AF8qCvD;AE7qCI;EAAS,eAAA;EAAiB,YAAA;EAAc,6BAAA;EAA+B,uBAAA;EAAyB,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AFsrC1I;AErrCM;EAAyB,qBAAA;AFwrC/B;AExrCwD;EAAO,8BAAA;EAAgC,oBAAA;AF4rC/F;AE5rCuH;EAAa,YAAA;EAAc,eAAA;AFgsClJ;AE/rCE;EAAU,YAAA;EAAc,YAAA;EAAc,WAAA;AFosCxC;;AElsCA;EAAY,yEAAA;EAA2E,0BAAA;EAA4B,qCAAA;EAAuC,kBAAA;EAAoB,YAAA;AF0sC9K;;AEzsCA;EAAqB;IAAK,6BAAA;EF8sCxB;EE9sCyD;IAAO,0BAAA;EFitChE;AACF;AEjtCA;EAAS,kBAAA;EAAoB,kBAAA;EAAoB,mBAAA;AFstCjD;AEttCsE;EAAM,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,kBAAA;AF4tC7H;AE5tCmJ;EAAS,cAAA;EAAgB,kBAAA;EAAoB,eAAA;AFiuChM;;AEhuCA;EAAS,kBAAA;EAAoB,+BAAA;EAAiC,eAAA;EAAiB,8BAAA;EAAgC,cAAA;EAAgB,yBAAA;AFyuC/H;AExuCE;EAAS,8BAAA;EAAgC,oBAAA;EAAsB,yBAAA;AF6uCjE;AE7uC8F;EAAY,+BAAA;EAAiC,cAAA;EAAgB,qBAAA;AFkvC3J;;AEjvCA;EAAW,WAAA;EAAa,YAAA;EAAc,sCAAA;EAAwC,+BAAA;EAAiC,kBAAA;EAAoB,oCAAA;EAAsC,qBAAA;AF2vCzK;;AE1vCA;EAAkB;IAAK,yBAAA;EF+vCrB;AACF;AE9vCA;EAAW,eAAA;EAAiB,QAAA;EAAU,kCAAA;EAAoC,WAAA;EAAa,aAAA;EAAe,yBAAA;EAA2B,qBAAA;AFuwCjI;;AEtwCA;EAAU,uBAAA;EAAyB,YAAA;EAAc,0BAAA;EAA4B,aAAA;EAAe,sBAAA;EAAwB,4BAAA;EAA8B,0BAAA;AFgxClJ;AE/wCE;EAAW,uBAAA;AFkxCb;AElxCwC;EAAS,wBAAA;AFqxCjD;AErxC6E;EAAS,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,sCAAA;AF4xCzJ;AE5xCiM;EAAK,eAAA;AF+xCtM;AE9xCE;EAAQ,SAAA;EAAS,cAAA;EAAgB,aAAA;AFmyCnC;AEnyCoD;EAAS,aAAA;EAAe,SAAA;EAAW,yBAAA;EAA2B,kBAAA;EAAoB,mCAAA;EAAqC,4BAAA;AF2yC3K;;AE1yCA;EAAkB,uBAAA;EAAyB,mBAAA;AF+yC3C;AE/yCgE;EAAU,YAAA;EAAc,gBAAA;EAAkB,sBAAA;EAAwB,4BAAA;EAA8B,yBAAA;AFszChK;;AErzCA;EAAkB;IAAO,UAAA;EF0zCvB;AACF;AE3zCyC;EAAmB;IAAO,2BAAA;IAA6B,UAAA;EFg0C9F;AACF;AEj0CgH;EAAiB;IAAO,sBAAA;IAAwB,UAAA;EFs0C9J;AACF;AEt0CA;EAAU,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,YAAA;EAAc,aAAA;EAAe,sBAAA;EAAwB,QAAA;AF+0C3G;AE90CE;EAAS,gBAAA;EAAkB,gBAAA;EAAkB,kBAAA;EAAoB,+BAAA;EAAiC,mBAAA;EAAqB,WAAA;EAAa,4BAAA;EAA8B,0BAAA;AFw1CpK;AEv1CI;EAAU,mBAAA;AF01Cd;AE11CqC;EAAY,mBAAA;AF61CjD;;AE51CA;EAAa,aAAA;EAAe,gDAAA;EAAkD,SAAA;AFk2C9E;AEl2CyF;EAAQ,iBAAA;AFq2CjG;;AEp2CA;EAA4B;IAAa,0BAAA;EFy2CvC;AACF;AEz2CA;EAAa,aAAA;EAAe,kBAAA;AF62C5B;;AE52CA;EAAS,kBAAA;EAAoB,YAAA;AFi3C7B;AEh3CE;EAAiB,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,eAAA;EAAiB,mBAAA;AFw3CpG;AEv3CI;EAAQ,kBAAA;EAAoB,2BAAA;AF23ChC;AE33C+D;EAAQ,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AFg4ClH;AE/3CI;EAAS,yBAAA;EAA2B,wBAAA;EAA0B,oBAAA;EAAsB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AFu4CzH;AEv4C6I;EAAM,wBAAA;EAA0B,oBAAA;EAAsB,UAAA;AF44CnM;AE34CE;EAAe,kBAAA;EAAoB,WAAA;EAAa,qBAAA;EAAuB,OAAA;EAAS,eAAA;EAAiB,kBAAA;EAAoB,gBAAA;EACnH,0BAAA;EAA4B,+BAAA;EAAiC,4BAAA;EAA8B,4BAAA;EAA8B,YAAA;EAAc,aAAA;EAAe,sBAAA;EAAwB,QAAA;AF25ClL;AE15CE;EAAiB,aAAA;EAAe,8BAAA;EAAgC,cAAA;EAAgB,eAAA;AFg6ClF;AEh6CmG;EAAiB,YAAA;EAAc,eAAA;EAAiB,qBAAA;AFq6CnJ;AEp6CE;EAAc,iBAAA;EAAmB,cAAA;EAAgB,aAAA;EAAe,sBAAA;AF06ClE;AEz6CI;EAAS,gBAAA;EAAkB,kBAAA;AF66C/B;AE76CmD;EAAU,qBAAA;AFg7C7D;;AE96CA;EAAQ,gBAAA;EAAkB,SAAA;EAAW,UAAA;EAAY,oBAAA;EAAsB,aAAA;EAAe,gBAAA;EAAkB,eAAA;AFw7CxG;AEx7CyH;EAAU,0BAAA;AF27CnI;;AEz7CA;EAAW,uCAAA;EAAyC,wCAAA;EAA0C,+BAAA;EAAiC,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;AFm8CtL;AEl8CE;EAAU,eAAA;EAAiB,gBAAA;AFs8C7B;AEt8CiD;EAAI,eAAA;AFy8CrD","sourcesContent":[":root {\n  --bg: #f5f7fb;\n  --surface: #ffffff;\n  --surface-2: #f9fafc;\n  --border: #e6e9f0;\n  --border-strong: #d0d5dd;\n  --text: #101828;\n  --muted: #667085;\n  --subtle: #98a2b3;\n\n  --accent: #1f75e0;\n  --accent-soft: #eaf2fd;\n  --accent-ink: #ffffff;\n\n  --success: #12b76a;\n  --success-soft: #ecfdf3;\n  --danger: #f04438;\n  --danger-soft: #fef3f2;\n  --warning: #f79009;\n  --warning-soft: #fffaeb;\n\n  --radius: 12px;\n  --radius-sm: 8px;\n  --shadow-sm: 0 1px 2px rgba(16, 24, 40, 0.05);\n  --shadow: 0 1px 3px rgba(16, 24, 40, 0.08), 0 1px 2px rgba(16, 24, 40, 0.05);\n  --shadow-lg: 0 16px 40px rgba(16, 24, 40, 0.14);\n  --sidebar: 232px;\n  --topbar: 64px;\n  --font: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n}\n\n// Each organization re-themes the whole interface.\n[data-org='della'] { --accent: #1f75e0; --accent-soft: #eaf2fd; }\n[data-org='vrd canada'] { --accent: #01497c; --accent-soft: #e6eff5; }\n[data-org='vezita'] { --accent: #e8770a; --accent-soft: #fef1e2; }\n[data-org='combined'] { --accent: #5b3fd0; --accent-soft: #efebfb; }\n\n* { box-sizing: border-box; }\nhtml, body, #root { height: 100%; }\nbody {\n  margin: 0;\n  background: var(--bg);\n  color: var(--text);\n  font-family: var(--font);\n  font-size: 14px;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\nh1, h2, h3, h4, p { margin: 0; }\nh1 { font-size: 22px; font-weight: 700; letter-spacing: -0.01em; }\nh2 { font-size: 16px; font-weight: 650; }\nh3 { font-size: 14px; font-weight: 650; }\nbutton, input, select, textarea { font: inherit; color: inherit; }\nbutton { cursor: pointer; }\na { color: var(--accent); text-decoration: none; }\na:hover { text-decoration: underline; }\n:focus-visible { outline: 2px solid var(--accent); outline-offset: 2px; }\n::selection { background: var(--accent-soft); }\n.muted { color: var(--muted); }\n.num { font-variant-numeric: tabular-nums; }\n.row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }\n.grow { flex: 1; min-width: 0; }\n.right { margin-left: auto; }\n.stack { display: flex; flex-direction: column; gap: 16px; }\n.grid { display: grid; gap: 16px; }\n.grid.cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.grid.cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n.grid.cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n@media (max-width: 1100px) { .grid.cols-3, .grid.cols-4 { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n@media (max-width: 700px) { .grid.cols-2, .grid.cols-3, .grid.cols-4 { grid-template-columns: 1fr; } }\n",":root {\n  --bg: #f5f7fb;\n  --surface: #ffffff;\n  --surface-2: #f9fafc;\n  --border: #e6e9f0;\n  --border-strong: #d0d5dd;\n  --text: #101828;\n  --muted: #667085;\n  --subtle: #98a2b3;\n  --accent: #1f75e0;\n  --accent-soft: #eaf2fd;\n  --accent-ink: #ffffff;\n  --success: #12b76a;\n  --success-soft: #ecfdf3;\n  --danger: #f04438;\n  --danger-soft: #fef3f2;\n  --warning: #f79009;\n  --warning-soft: #fffaeb;\n  --radius: 12px;\n  --radius-sm: 8px;\n  --shadow-sm: 0 1px 2px rgba(16, 24, 40, 0.05);\n  --shadow: 0 1px 3px rgba(16, 24, 40, 0.08), 0 1px 2px rgba(16, 24, 40, 0.05);\n  --shadow-lg: 0 16px 40px rgba(16, 24, 40, 0.14);\n  --sidebar: 232px;\n  --topbar: 64px;\n  --font: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n}\n\n[data-org=della] {\n  --accent: #1f75e0;\n  --accent-soft: #eaf2fd;\n}\n\n[data-org=\"vrd canada\"] {\n  --accent: #01497c;\n  --accent-soft: #e6eff5;\n}\n\n[data-org=vezita] {\n  --accent: #e8770a;\n  --accent-soft: #fef1e2;\n}\n\n[data-org=combined] {\n  --accent: #5b3fd0;\n  --accent-soft: #efebfb;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body, #root {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  background: var(--bg);\n  color: var(--text);\n  font-family: var(--font);\n  font-size: 14px;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\nh1, h2, h3, h4, p {\n  margin: 0;\n}\n\nh1 {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\nh2 {\n  font-size: 16px;\n  font-weight: 650;\n}\n\nh3 {\n  font-size: 14px;\n  font-weight: 650;\n}\n\nbutton, input, select, textarea {\n  font: inherit;\n  color: inherit;\n}\n\nbutton {\n  cursor: pointer;\n}\n\na {\n  color: var(--accent);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n}\n\n::selection {\n  background: var(--accent-soft);\n}\n\n.muted {\n  color: var(--muted);\n}\n\n.num {\n  font-variant-numeric: tabular-nums;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.grow {\n  flex: 1;\n  min-width: 0;\n}\n\n.right {\n  margin-left: auto;\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.grid {\n  display: grid;\n  gap: 16px;\n}\n\n.grid.cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.grid.cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.grid.cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n@media (max-width: 1100px) {\n  .grid.cols-3, .grid.cols-4 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 700px) {\n  .grid.cols-2, .grid.cols-3, .grid.cols-4 {\n    grid-template-columns: 1fr;\n  }\n}\n.shell {\n  display: grid;\n  grid-template-columns: var(--sidebar) 1fr;\n  min-height: 100%;\n}\n\n.sidebar {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface);\n  border-right: 1px solid var(--border);\n  padding: 16px 12px;\n  z-index: 30;\n}\n.sidebar .brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 8px 20px;\n  font-weight: 700;\n  font-size: 16px;\n}\n.sidebar .brand img {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n}\n.sidebar .brand small {\n  display: block;\n  font-weight: 500;\n  color: var(--muted);\n  font-size: 11px;\n}\n.sidebar nav {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.sidebar .nav-label {\n  padding: 14px 10px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--subtle);\n}\n.sidebar .nav-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: var(--radius-sm);\n  color: var(--muted);\n  font-weight: 550;\n  text-decoration: none;\n}\n.sidebar .nav-link svg {\n  width: 18px;\n  height: 18px;\n  flex: none;\n}\n.sidebar .nav-link:hover {\n  background: var(--surface-2);\n  color: var(--text);\n  text-decoration: none;\n}\n.sidebar .nav-link.active {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n.sidebar .sidebar-foot {\n  margin-top: auto;\n  padding: 10px;\n  font-size: 12px;\n  color: var(--subtle);\n}\n\n.main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.topbar {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  height: var(--topbar);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 0 24px;\n  background: rgba(255, 255, 255, 0.86);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--border);\n}\n.topbar .burger {\n  display: none;\n}\n\n.content {\n  padding: 24px;\n  width: 100%;\n  max-width: 1480px;\n  margin: 0 auto;\n}\n\n.page-head {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n.page-head p {\n  color: var(--muted);\n  margin-top: 2px;\n}\n.page-head .actions {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.scrim {\n  display: none;\n}\n\n.org-select {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-width: 0;\n}\n.org-select .dot {\n  position: absolute;\n  left: 12px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--accent);\n  pointer-events: none;\n}\n.org-select select {\n  appearance: none;\n  height: 38px;\n  max-width: 100%;\n  padding: 0 36px 0 30px;\n  border: 1px solid var(--border-strong);\n  border-radius: 10px;\n  background: var(--surface);\n  font-weight: 650;\n  box-shadow: var(--shadow-sm);\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%23667085' stroke-width='2'%3E%3Cpath d='m4 6 4 4 4-4'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n}\n.org-select select:hover {\n  border-color: var(--accent);\n}\n.org-select select:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n\n.user-menu {\n  position: relative;\n  margin-left: auto;\n}\n.user-menu .trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 0;\n  background: transparent;\n  padding: 4px 6px;\n  border-radius: 10px;\n}\n.user-menu .trigger:hover {\n  background: var(--bg);\n}\n.user-menu .trigger .who {\n  text-align: left;\n  line-height: 1.2;\n}\n.user-menu .trigger .who small {\n  display: block;\n  color: var(--muted);\n  font-size: 12px;\n}\n.user-menu .dropdown {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 8px);\n  min-width: 220px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n  padding: 6px;\n  z-index: 50;\n}\n.user-menu .dropdown button {\n  display: block;\n  width: 100%;\n  text-align: left;\n  border: 0;\n  background: transparent;\n  padding: 9px 10px;\n  border-radius: 8px;\n}\n.user-menu .dropdown button:hover {\n  background: var(--bg);\n}\n.user-menu .dropdown button.danger {\n  color: var(--danger);\n}\n.user-menu .dropdown hr {\n  border: 0;\n  border-top: 1px solid var(--border);\n  margin: 6px 0;\n}\n.user-menu .dropdown .head {\n  padding: 8px 10px;\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  flex: none;\n  background: var(--accent-soft);\n  color: var(--accent);\n  font-weight: 700;\n  font-size: 12px;\n}\n\n@media (max-width: 900px) {\n  .shell {\n    grid-template-columns: 1fr;\n  }\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 260px;\n    transform: translateX(-100%);\n    transition: transform 0.2s ease;\n    box-shadow: var(--shadow-lg);\n  }\n  .shell.nav-open .sidebar {\n    transform: none;\n  }\n  .shell.nav-open .scrim {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(16, 24, 40, 0.4);\n    z-index: 25;\n  }\n  .topbar {\n    padding: 0 14px;\n  }\n  .topbar .burger {\n    display: inline-flex;\n  }\n  .topbar .user-menu .who {\n    display: none;\n  }\n  .content {\n    padding: 16px;\n  }\n}\n.auth-page {\n  --ink: #0b1b3f;\n  --soft: #5d6b88;\n  --blue-a: #2c9be0;\n  --blue-b: #2050a0;\n  --lift: 8px 8px 18px rgba(150, 166, 204, 0.42), -8px -8px 18px rgba(255, 255, 255, 0.95);\n  position: relative;\n  overflow: hidden;\n  min-height: 100%;\n  display: grid;\n  background: linear-gradient(160deg, #f1f5fd 0%, #e3ebf9 55%, #d9e4f6 100%);\n  color: var(--ink);\n}\n.auth-page .shape {\n  position: absolute;\n  border-radius: 50%;\n  pointer-events: none;\n  background: linear-gradient(145deg, #f7faff, #dbe6f8);\n  box-shadow: inset 0 0 0 10px rgba(255, 255, 255, 0.55), inset 0 0 0 22px rgba(120, 160, 235, 0.22), 14px 14px 40px rgba(150, 166, 204, 0.3);\n}\n.auth-page .shape.s1 {\n  width: 340px;\n  height: 340px;\n  left: -150px;\n  top: -150px;\n}\n.auth-page .shape.s2 {\n  width: 150px;\n  height: 150px;\n  right: -64px;\n  top: 30%;\n  background: linear-gradient(145deg, #dfeafc, #b9d0f6);\n}\n.auth-page .shape.s3 {\n  width: 220px;\n  height: 220px;\n  left: -100px;\n  bottom: 6%;\n}\n.auth-page .shape.s4 {\n  width: 420px;\n  height: 420px;\n  right: -190px;\n  bottom: -190px;\n}\n.auth-page .form-panel {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 26px;\n  padding: 40px 24px;\n}\n.auth-page form {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  align-items: stretch;\n  animation: card-in 0.55s cubic-bezier(0.2, 0.7, 0.2, 1) both;\n}\n.auth-page .logo-tile {\n  align-self: center;\n  display: grid;\n  place-items: center;\n  width: 148px;\n  height: 148px;\n  margin-bottom: 4px;\n  border-radius: 42px;\n  animation: float 7s ease-in-out infinite;\n  background: linear-gradient(145deg, #ffffff, #e4ecfa);\n  box-shadow: var(--lift), inset 0 0 0 2px rgba(255, 255, 255, 0.8), inset -6px -6px 14px rgba(150, 166, 204, 0.18);\n}\n.auth-page .logo-tile img {\n  width: 96px;\n  height: 96px;\n  display: block;\n  filter: drop-shadow(0 8px 10px rgba(32, 80, 160, 0.25));\n}\n.auth-page .form-head {\n  text-align: center;\n}\n.auth-page .form-head .brand-name {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.28em;\n  text-transform: uppercase;\n  color: var(--blue-b);\n  margin-bottom: 10px;\n}\n.auth-page .form-head h1 {\n  font-size: 36px;\n  line-height: 1.1;\n  letter-spacing: -0.03em;\n  font-weight: 800;\n  color: var(--ink);\n}\n.auth-page .form-head p {\n  margin: 10px 0 0;\n  font-size: 13px;\n  letter-spacing: 0.32em;\n  text-transform: lowercase;\n  color: var(--soft);\n}\n.auth-page .field.plain > label {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n.auth-page .with-icon {\n  position: relative;\n}\n.auth-page .with-icon .lead {\n  position: absolute;\n  left: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #33415f;\n  display: flex;\n  pointer-events: none;\n  transition: color 0.2s;\n}\n.auth-page .with-icon:focus-within .lead {\n  color: var(--blue-a);\n}\n.auth-page .with-icon .input {\n  height: 60px;\n  padding: 0 56px;\n  font-size: 16px;\n  color: var(--ink);\n  border: 0;\n  border-radius: 22px;\n  background: linear-gradient(145deg, #f3f7fd, #e8eefa);\n  box-shadow: var(--lift), inset 0 0 0 1.5px rgba(255, 255, 255, 0.75);\n  transition: box-shadow 0.2s, background 0.2s;\n}\n.auth-page .with-icon .input::placeholder {\n  color: #7d8aa8;\n}\n.auth-page .with-icon .input:hover {\n  box-shadow: 10px 10px 22px rgba(150, 166, 204, 0.46), -8px -8px 18px rgb(255, 255, 255), inset 0 0 0 1.5px rgba(255, 255, 255, 0.75);\n}\n.auth-page .with-icon .input:focus {\n  background: #edf2fb;\n  box-shadow: inset 5px 5px 11px rgba(150, 166, 204, 0.4), inset -5px -5px 11px rgba(255, 255, 255, 0.95), 0 0 0 3px rgba(44, 155, 224, 0.35);\n}\n.auth-page .with-icon .reveal {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 42px;\n  height: 42px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 14px;\n  background: transparent;\n  color: #33415f;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\n}\n.auth-page .with-icon .reveal:hover {\n  color: var(--blue-b);\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: 3px 3px 8px rgba(150, 166, 204, 0.3);\n}\n.auth-page .with-icon .reveal:focus-visible {\n  outline: 2px solid var(--blue-a);\n}\n.auth-page .alert {\n  border-radius: 18px;\n  padding: 12px 16px;\n  font-weight: 500;\n  text-align: center;\n  background: #fff1f0;\n  border: 0;\n  box-shadow: var(--lift);\n  animation: card-in 0.25s ease both;\n}\n.auth-page .signin {\n  position: relative;\n  height: 62px;\n  margin-top: 6px;\n  border: 0;\n  border-radius: 31px;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  color: #fff;\n  background: linear-gradient(135deg, var(--blue-a) 0%, #2a6fd0 50%, var(--blue-b) 100%);\n  box-shadow: 0 16px 30px -8px rgba(32, 80, 160, 0.65), inset 0 2px 0 rgba(255, 255, 255, 0.35), inset 0 -3px 6px rgba(10, 30, 90, 0.25);\n  transition: transform 0.18s, box-shadow 0.18s;\n}\n.auth-page .signin .spinner {\n  border-color: rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n}\n.auth-page .signin .go {\n  position: absolute;\n  right: 9px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 44px;\n  height: 44px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.22);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);\n  transition: transform 0.18s, background 0.18s;\n}\n.auth-page .signin:hover:not(:disabled) {\n  filter: none;\n  background: linear-gradient(135deg, #3aa6ea 0%, #2a6fd0 50%, var(--blue-b) 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 20px 34px -8px rgba(32, 80, 160, 0.75), inset 0 2px 0 rgba(255, 255, 255, 0.35), inset 0 -3px 6px rgba(10, 30, 90, 0.25);\n}\n.auth-page .signin:hover:not(:disabled) .go {\n  transform: translateY(-50%) translateX(3px);\n  background: rgba(255, 255, 255, 0.32);\n}\n.auth-page .signin:active:not(:disabled) {\n  transform: translateY(0);\n}\n.auth-page .signin:focus-visible {\n  outline: 3px solid rgba(44, 155, 224, 0.5);\n  outline-offset: 3px;\n}\n.auth-page .signin:disabled {\n  opacity: 0.55;\n  box-shadow: 0 8px 16px -8px rgba(32, 80, 160, 0.4);\n}\n.auth-page .help {\n  text-align: center;\n  font-size: 13px;\n  color: var(--soft);\n  margin: 4px 0 0;\n}\n.auth-page .tagline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.26em;\n  text-transform: uppercase;\n  color: #5d6b88;\n}\n.auth-page .tagline i {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--blue-a);\n}\n\n@media (min-width: 700px) {\n  .auth-page .form-panel form {\n    max-width: 460px;\n    padding: 48px 48px 40px;\n    border-radius: 44px;\n    background: linear-gradient(145deg, rgba(255, 255, 255, 0.78), rgba(232, 239, 251, 0.78));\n    box-shadow: 18px 18px 44px rgba(150, 166, 204, 0.4), -14px -14px 34px rgba(255, 255, 255, 0.95), inset 0 0 0 2px rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(8px);\n  }\n  .auth-page .shape.s1 {\n    width: 520px;\n    height: 520px;\n    left: -220px;\n    top: -220px;\n  }\n  .auth-page .shape.s2 {\n    width: 220px;\n    height: 220px;\n    right: -90px;\n    top: 28%;\n  }\n  .auth-page .shape.s3 {\n    width: 320px;\n    height: 320px;\n    left: -140px;\n    bottom: 4%;\n  }\n  .auth-page .shape.s4 {\n    width: 620px;\n    height: 620px;\n    right: -270px;\n    bottom: -270px;\n  }\n}\n@media (max-height: 760px) {\n  .auth-page .logo-tile {\n    width: 112px;\n    height: 112px;\n    border-radius: 32px;\n  }\n  .auth-page .logo-tile img {\n    width: 72px;\n    height: 72px;\n  }\n  .auth-page .form-head h1 {\n    font-size: 30px;\n  }\n  .auth-page .form-panel {\n    gap: 18px;\n    padding: 24px;\n  }\n  .auth-page form {\n    gap: 14px;\n  }\n}\n@media (min-width: 700px) and (max-height: 760px) {\n  .auth-page .form-panel form {\n    padding: 32px 44px 28px;\n  }\n}\n.auth-page .with-icon .input.invalid, .auth-page .with-icon .input.invalid:focus {\n  box-shadow: var(--lift), 0 0 0 3px rgba(240, 68, 56, 0.4);\n}\n\n.auth-page .field .err {\n  text-align: left;\n  padding-left: 6px;\n  font-size: 13px;\n}\n\n.auth-page ::selection {\n  background: #2c8de0;\n  color: #fff;\n}\n\n.auth-page .input:-webkit-autofill, .auth-page .input:-webkit-autofill:focus {\n  -webkit-text-fill-color: var(--ink);\n  caret-color: var(--ink);\n  box-shadow: var(--lift), inset 0 0 0 100px #d4e6fb;\n  transition: background-color 9999s;\n}\n\n@media (max-width: 420px) {\n  .auth-page .tagline {\n    gap: 7px;\n    font-size: 10px;\n    letter-spacing: 0.14em;\n  }\n}\n@keyframes card-in {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-6px);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .auth-page * {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 38px;\n  padding: 0 14px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: var(--surface);\n  font-weight: 600;\n  box-shadow: var(--shadow-sm);\n  white-space: nowrap;\n  transition: background 0.15s, border-color 0.15s;\n}\n.btn svg {\n  width: 16px;\n  height: 16px;\n}\n.btn:hover:not(:disabled) {\n  background: var(--surface-2);\n}\n.btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.btn.primary {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--accent-ink);\n}\n.btn.primary:hover:not(:disabled) {\n  filter: brightness(0.94);\n  background: var(--accent);\n}\n.btn.danger {\n  color: var(--danger);\n  border-color: #fda29b;\n}\n.btn.danger:hover:not(:disabled) {\n  background: var(--danger-soft);\n}\n.btn.ghost {\n  border-color: transparent;\n  background: transparent;\n  box-shadow: none;\n}\n.btn.ghost:hover:not(:disabled) {\n  background: var(--bg);\n}\n.btn.sm {\n  height: 30px;\n  padding: 0 10px;\n  font-size: 13px;\n}\n.btn.icon {\n  width: 38px;\n  padding: 0;\n}\n.btn.icon.sm {\n  width: 30px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n.field > label, .field .label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #344054;\n}\n.field .hint {\n  font-size: 12px;\n  color: var(--muted);\n}\n.field .err {\n  font-size: 12px;\n  color: var(--danger);\n}\n\n.input, .select, .textarea {\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  box-shadow: var(--shadow-sm);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.input::placeholder, .select::placeholder, .textarea::placeholder {\n  color: var(--subtle);\n}\n.input:focus, .select:focus, .textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n.input:disabled, .select:disabled, .textarea:disabled {\n  background: var(--bg);\n  color: var(--muted);\n}\n.input.invalid, .select.invalid, .textarea.invalid {\n  border-color: var(--danger);\n}\n.input.invalid:focus, .select.invalid:focus, .textarea.invalid:focus {\n  box-shadow: 0 0 0 3px var(--danger-soft);\n}\n\n.select {\n  appearance: none;\n  padding-right: 32px;\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%23667085' stroke-width='2'%3E%3Cpath d='m4 6 4 4 4-4'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n}\n\n.textarea {\n  height: auto;\n  min-height: 84px;\n  padding: 10px 12px;\n  resize: vertical;\n}\n\n.search {\n  position: relative;\n}\n.search svg {\n  position: absolute;\n  left: 11px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  color: var(--subtle);\n}\n.search .input {\n  padding-left: 34px;\n}\n\n.check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n.check input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--accent);\n}\n\n.card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n.card .card-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border);\n}\n.card .card-head p {\n  color: var(--muted);\n  font-size: 13px;\n}\n.card .card-body {\n  padding: 20px;\n}\n.card.flush .card-body {\n  padding: 0;\n}\n\n.stat {\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.stat .label {\n  color: var(--muted);\n  font-weight: 550;\n  font-size: 13px;\n}\n.stat .value {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  font-variant-numeric: tabular-nums;\n}\n.stat .sub {\n  color: var(--muted);\n  font-size: 12px;\n}\n.stat.clickable {\n  cursor: pointer;\n  transition: box-shadow 0.15s, border-color 0.15s;\n}\n.stat.clickable:hover {\n  border-color: var(--accent);\n  box-shadow: var(--shadow);\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--bg);\n  color: #344054;\n  white-space: nowrap;\n}\n.badge.success {\n  background: var(--success-soft);\n  color: #027a48;\n}\n.badge.danger {\n  background: var(--danger-soft);\n  color: #b42318;\n}\n.badge.warning {\n  background: var(--warning-soft);\n  color: #b54708;\n}\n.badge.accent {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n\n.chip {\n  border: 1px solid var(--border-strong);\n  background: var(--surface);\n  border-radius: 999px;\n  padding: 5px 12px;\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--muted);\n}\n.chip:hover {\n  color: var(--text);\n}\n.chip.on {\n  background: var(--accent-soft);\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--border);\n  overflow-x: auto;\n}\n.tabs button {\n  border: 0;\n  background: transparent;\n  padding: 10px 14px;\n  font-weight: 600;\n  color: var(--muted);\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  white-space: nowrap;\n}\n.tabs button:hover {\n  color: var(--text);\n}\n.tabs button.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.seg {\n  display: inline-flex;\n  padding: 3px;\n  background: var(--bg);\n  border-radius: 9px;\n}\n.seg button {\n  border: 0;\n  background: transparent;\n  padding: 6px 12px;\n  border-radius: 7px;\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--muted);\n}\n.seg button.on {\n  background: var(--surface);\n  color: var(--text);\n  box-shadow: var(--shadow);\n}\n\n.progress {\n  height: 8px;\n  background: var(--bg);\n  border-radius: 999px;\n  overflow: hidden;\n}\n.progress > i {\n  display: block;\n  height: 100%;\n  background: var(--accent);\n  border-radius: 999px;\n  transition: width 0.4s;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n}\n.toolbar .search {\n  flex: 1 1 240px;\n  max-width: 360px;\n}\n.toolbar .select {\n  width: auto;\n  min-width: 140px;\n}\n\n.table-wrap {\n  overflow: auto;\n  position: relative;\n}\n\n.table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  min-width: 640px;\n}\n.table th {\n  position: sticky;\n  top: 0;\n  background: var(--surface-2);\n  text-align: left;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n  user-select: none;\n}\n.table th.sortable {\n  cursor: pointer;\n}\n.table th.sortable:hover {\n  color: var(--text);\n}\n.table th .arrow {\n  margin-left: 4px;\n  color: var(--accent);\n}\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border);\n  vertical-align: middle;\n}\n.table tbody tr {\n  transition: background 0.1s;\n}\n.table tbody tr:last-child td {\n  border-bottom: 0;\n}\n.table tbody tr.clickable {\n  cursor: pointer;\n}\n.table tbody tr:hover {\n  background: var(--surface-2);\n}\n.table .r {\n  text-align: right;\n}\n.table .c {\n  text-align: center;\n}\n\n.pager {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 20px;\n  border-top: 1px solid var(--border);\n  font-size: 13px;\n  color: var(--muted);\n}\n.pager .pages {\n  display: flex;\n  gap: 4px;\n  margin-left: auto;\n  align-items: center;\n}\n.pager .pages button {\n  min-width: 32px;\n  height: 32px;\n  border: 1px solid transparent;\n  background: transparent;\n  border-radius: 8px;\n  font-weight: 600;\n  color: var(--muted);\n}\n.pager .pages button:hover:not(:disabled) {\n  background: var(--bg);\n}\n.pager .pages button.on {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n.pager .pages button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.pager .select {\n  height: 32px;\n  min-width: 0;\n  width: auto;\n}\n\n.skeleton {\n  background: linear-gradient(90deg, #eef1f6 25%, #f6f8fb 37%, #eef1f6 63%);\n  background-size: 400% 100%;\n  animation: shimmer 1.3s ease infinite;\n  border-radius: 6px;\n  height: 14px;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n.empty {\n  padding: 48px 20px;\n  text-align: center;\n  color: var(--muted);\n}\n.empty svg {\n  width: 36px;\n  height: 36px;\n  color: var(--subtle);\n  margin-bottom: 8px;\n}\n.empty strong {\n  display: block;\n  color: var(--text);\n  font-size: 15px;\n}\n\n.alert {\n  padding: 12px 14px;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  background: var(--danger-soft);\n  color: #b42318;\n  border: 1px solid #fecdca;\n}\n.alert.info {\n  background: var(--accent-soft);\n  color: var(--accent);\n  border-color: transparent;\n}\n.alert.warning {\n  background: var(--warning-soft);\n  color: #b54708;\n  border-color: #fedf89;\n}\n\n.spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--border-strong);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n  display: inline-block;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(16, 24, 40, 0.45);\n  z-index: 60;\n  display: flex;\n  justify-content: flex-end;\n  animation: fade 0.15s;\n}\n\n.drawer {\n  width: min(720px, 100%);\n  height: 100%;\n  background: var(--surface);\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow-lg);\n  animation: slide 0.2s ease;\n}\n.drawer.narrow {\n  width: min(520px, 100%);\n}\n.drawer.wide {\n  width: min(1080px, 100%);\n}\n.drawer header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 24px;\n  border-bottom: 1px solid var(--border);\n}\n.drawer header h2 {\n  font-size: 18px;\n}\n.drawer .body {\n  flex: 1;\n  overflow: auto;\n  padding: 24px;\n}\n.drawer footer {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding: 14px 24px;\n  border-top: 1px solid var(--border);\n  background: var(--surface-2);\n}\n\n.overlay.center {\n  justify-content: center;\n  align-items: center;\n}\n.overlay.center .drawer {\n  height: auto;\n  max-height: 90vh;\n  width: min(460px, 94%);\n  border-radius: var(--radius);\n  animation: pop 0.15s ease;\n}\n\n@keyframes fade {\n  from {\n    opacity: 0;\n  }\n}\n@keyframes slide {\n  from {\n    transform: translateX(32px);\n    opacity: 0;\n  }\n}\n@keyframes pop {\n  from {\n    transform: scale(0.96);\n    opacity: 0;\n  }\n}\n.toasts {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.toasts .toast {\n  min-width: 260px;\n  max-width: 380px;\n  padding: 12px 14px;\n  border-radius: var(--radius-sm);\n  background: #101828;\n  color: #fff;\n  box-shadow: var(--shadow-lg);\n  animation: slide 0.2s ease;\n}\n.toasts .toast.error {\n  background: #b42318;\n}\n.toasts .toast.success {\n  background: #067647;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n.form-grid .full {\n  grid-column: 1/-1;\n}\n\n@media (max-width: 600px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.chart-box {\n  height: 320px;\n  position: relative;\n}\n\n.multi {\n  position: relative;\n  min-width: 0;\n}\n.multi .multi-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-align: left;\n  cursor: pointer;\n  color: var(--muted);\n}\n.multi .multi-trigger.has {\n  color: var(--text);\n  border-color: var(--accent);\n}\n.multi .multi-trigger .grow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.multi .multi-trigger .count {\n  background: var(--accent);\n  color: var(--accent-ink);\n  border-radius: 999px;\n  padding: 0 7px;\n  font-size: 11px;\n  font-weight: 700;\n}\n.multi .multi-trigger svg {\n  transform: rotate(90deg);\n  color: var(--subtle);\n  flex: none;\n}\n.multi .multi-panel {\n  position: absolute;\n  z-index: 40;\n  top: calc(100% + 6px);\n  left: 0;\n  min-width: 100%;\n  width: max-content;\n  max-width: 360px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.multi .multi-actions {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 4px;\n  font-size: 12px;\n}\n.multi .multi-actions .link:disabled {\n  opacity: 0.4;\n  cursor: default;\n  text-decoration: none;\n}\n.multi .multi-list {\n  max-height: 260px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n.multi .multi-list .check {\n  padding: 7px 8px;\n  border-radius: 6px;\n}\n.multi .multi-list .check:hover {\n  background: var(--bg);\n}\n\n.link {\n  background: none;\n  border: 0;\n  padding: 0;\n  color: var(--accent);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n}\n.link:hover {\n  text-decoration: underline;\n}\n\n.purpose {\n  background: var(--accent-soft, #eff6ff);\n  border: 1px solid var(--border, #d0d5dd);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  font-size: 13px;\n  line-height: 1.5;\n  margin-bottom: 16px;\n}\n.purpose summary {\n  cursor: pointer;\n  font-weight: 600;\n}\n.purpose p {\n  margin: 6px 0 0;\n}",".shell { display: grid; grid-template-columns: var(--sidebar) 1fr; min-height: 100%; }\n.sidebar {\n  position: sticky; top: 0; height: 100vh; display: flex; flex-direction: column;\n  background: var(--surface); border-right: 1px solid var(--border); padding: 16px 12px; z-index: 30;\n  .brand { display: flex; align-items: center; gap: 10px; padding: 4px 8px 20px; font-weight: 700; font-size: 16px;\n    img { width: 32px; height: 32px; object-fit: contain; } small { display: block; font-weight: 500; color: var(--muted); font-size: 11px; } }\n  nav { display: flex; flex-direction: column; gap: 2px; }\n  .nav-label { padding: 14px 10px 6px; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: var(--subtle); }\n  .nav-link {\n    display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: var(--radius-sm);\n    color: var(--muted); font-weight: 550; text-decoration: none;\n    svg { width: 18px; height: 18px; flex: none; }\n    &:hover { background: var(--surface-2); color: var(--text); text-decoration: none; }\n    &.active { background: var(--accent-soft); color: var(--accent); }\n  }\n  .sidebar-foot { margin-top: auto; padding: 10px; font-size: 12px; color: var(--subtle); }\n}\n.main { min-width: 0; display: flex; flex-direction: column; }\n.topbar {\n  position: sticky; top: 0; z-index: 20; height: var(--topbar); display: flex; align-items: center; gap: 16px;\n  padding: 0 24px; background: rgba(255, 255, 255, 0.86); backdrop-filter: blur(10px); border-bottom: 1px solid var(--border);\n  .burger { display: none; }\n}\n.content { padding: 24px; width: 100%; max-width: 1480px; margin: 0 auto; }\n.page-head { display: flex; align-items: flex-end; gap: 16px; flex-wrap: wrap; margin-bottom: 20px;\n  p { color: var(--muted); margin-top: 2px; } .actions { margin-left: auto; display: flex; gap: 8px; flex-wrap: wrap; } }\n.scrim { display: none; }\n\n.org-select { position: relative; display: inline-flex; align-items: center; min-width: 0;\n  .dot { position: absolute; left: 12px; width: 10px; height: 10px; border-radius: 50%; background: var(--accent); pointer-events: none; }\n  select { appearance: none; height: 38px; max-width: 100%; padding: 0 36px 0 30px; border: 1px solid var(--border-strong); border-radius: 10px;\n    background: var(--surface); font-weight: 650; box-shadow: var(--shadow-sm); cursor: pointer;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%23667085' stroke-width='2'%3E%3Cpath d='m4 6 4 4 4-4'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat; background-position: right 10px center;\n    &:hover { border-color: var(--accent); } &:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); } }\n}\n.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }\n.user-menu { position: relative; margin-left: auto;\n  .trigger { display: flex; align-items: center; gap: 10px; border: 0; background: transparent; padding: 4px 6px; border-radius: 10px;\n    &:hover { background: var(--bg); } .who { text-align: left; line-height: 1.2; small { display: block; color: var(--muted); font-size: 12px; } } }\n  .dropdown { position: absolute; right: 0; top: calc(100% + 8px); min-width: 220px; background: var(--surface); border: 1px solid var(--border);\n    border-radius: var(--radius); box-shadow: var(--shadow-lg); padding: 6px; z-index: 50;\n    button { display: block; width: 100%; text-align: left; border: 0; background: transparent; padding: 9px 10px; border-radius: 8px;\n      &:hover { background: var(--bg); } &.danger { color: var(--danger); } }\n    hr { border: 0; border-top: 1px solid var(--border); margin: 6px 0; } .head { padding: 8px 10px; font-size: 12px; color: var(--muted); } }\n}\n.avatar { width: 34px; height: 34px; border-radius: 50%; display: grid; place-items: center; flex: none;\n  background: var(--accent-soft); color: var(--accent); font-weight: 700; font-size: 12px; }\n\n@media (max-width: 900px) {\n  .shell { grid-template-columns: 1fr; }\n  .sidebar { position: fixed; left: 0; top: 0; width: 260px; transform: translateX(-100%); transition: transform 0.2s ease; box-shadow: var(--shadow-lg); }\n  .shell.nav-open .sidebar { transform: none; }\n  .shell.nav-open .scrim { display: block; position: fixed; inset: 0; background: rgba(16, 24, 40, 0.4); z-index: 25; }\n  .topbar { padding: 0 14px; .burger { display: inline-flex; } .user-menu .who { display: none; } }\n  .content { padding: 16px; }\n}\n\n// Login page: soft, raised (\"neumorphic\") surfaces on a pale blue canvas. Blues come from the logo: #2090d0 to #2050a0.\n.auth-page { --ink: #0b1b3f; --soft: #5d6b88; --blue-a: #2c9be0; --blue-b: #2050a0; --lift: 8px 8px 18px rgba(150, 166, 204, 0.42), -8px -8px 18px rgba(255, 255, 255, 0.95);\n  position: relative; overflow: hidden; min-height: 100%; display: grid; background: linear-gradient(160deg, #f1f5fd 0%, #e3ebf9 55%, #d9e4f6 100%); color: var(--ink);\n\n  // Big rounded shapes in the corners, each with a blue rim like the reference.\n  .shape { position: absolute; border-radius: 50%; pointer-events: none; background: linear-gradient(145deg, #f7faff, #dbe6f8); box-shadow: inset 0 0 0 10px rgba(255, 255, 255, 0.55), inset 0 0 0 22px rgba(120, 160, 235, 0.22), 14px 14px 40px rgba(150, 166, 204, 0.3);\n    &.s1 { width: 340px; height: 340px; left: -150px; top: -150px; }\n    &.s2 { width: 150px; height: 150px; right: -64px; top: 30%; background: linear-gradient(145deg, #dfeafc, #b9d0f6); }\n    &.s3 { width: 220px; height: 220px; left: -100px; bottom: 6%; }\n    &.s4 { width: 420px; height: 420px; right: -190px; bottom: -190px; } }\n\n  .form-panel { position: relative; z-index: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 26px; padding: 40px 24px; }\n\n  form { width: 100%; max-width: 400px; display: flex; flex-direction: column; gap: 18px; align-items: stretch; animation: card-in 0.55s cubic-bezier(0.2, 0.7, 0.2, 1) both; }\n\n  .logo-tile { align-self: center; display: grid; place-items: center; width: 148px; height: 148px; margin-bottom: 4px; border-radius: 42px; animation: float 7s ease-in-out infinite;\n    background: linear-gradient(145deg, #ffffff, #e4ecfa); box-shadow: var(--lift), inset 0 0 0 2px rgba(255, 255, 255, 0.8), inset -6px -6px 14px rgba(150, 166, 204, 0.18);\n    img { width: 96px; height: 96px; display: block; filter: drop-shadow(0 8px 10px rgba(32, 80, 160, 0.25)); } }\n\n  .form-head { text-align: center; .brand-name { display: block; font-size: 12px; font-weight: 700; letter-spacing: 0.28em; text-transform: uppercase; color: var(--blue-b); margin-bottom: 10px; }\n    h1 { font-size: 36px; line-height: 1.1; letter-spacing: -0.03em; font-weight: 800; color: var(--ink); }\n    p { margin: 10px 0 0; font-size: 13px; letter-spacing: 0.32em; text-transform: lowercase; color: var(--soft); } }\n\n  .field.plain > label { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }\n\n  .with-icon { position: relative;\n    .lead { position: absolute; left: 20px; top: 50%; transform: translateY(-50%); color: #33415f; display: flex; pointer-events: none; transition: color 0.2s; }\n    &:focus-within .lead { color: var(--blue-a); }\n    .input { height: 60px; padding: 0 56px; font-size: 16px; color: var(--ink); border: 0; border-radius: 22px; background: linear-gradient(145deg, #f3f7fd, #e8eefa);\n      box-shadow: var(--lift), inset 0 0 0 1.5px rgba(255, 255, 255, 0.75); transition: box-shadow 0.2s, background 0.2s;\n      &::placeholder { color: #7d8aa8; } &:hover { box-shadow: 10px 10px 22px rgba(150, 166, 204, 0.46), -8px -8px 18px rgba(255, 255, 255, 1), inset 0 0 0 1.5px rgba(255, 255, 255, 0.75); }\n      &:focus { background: #edf2fb; box-shadow: inset 5px 5px 11px rgba(150, 166, 204, 0.4), inset -5px -5px 11px rgba(255, 255, 255, 0.95), 0 0 0 3px rgba(44, 155, 224, 0.35); } }\n    .reveal { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); width: 42px; height: 42px; display: grid; place-items: center; border: 0; border-radius: 14px;\n      background: transparent; color: #33415f; cursor: pointer; transition: background 0.2s, color 0.2s, box-shadow 0.2s;\n      &:hover { color: var(--blue-b); background: rgba(255, 255, 255, 0.7); box-shadow: 3px 3px 8px rgba(150, 166, 204, 0.3); } &:focus-visible { outline: 2px solid var(--blue-a); } } }\n\n  .alert { border-radius: 18px; padding: 12px 16px; font-weight: 500; text-align: center; background: #fff1f0; border: 0; box-shadow: var(--lift); animation: card-in 0.25s ease both; }\n\n  .signin { position: relative; height: 62px; margin-top: 6px; border: 0; border-radius: 31px; font-size: 18px; font-weight: 700; letter-spacing: 0.01em; color: #fff;\n    background: linear-gradient(135deg, var(--blue-a) 0%, #2a6fd0 50%, var(--blue-b) 100%); box-shadow: 0 16px 30px -8px rgba(32, 80, 160, 0.65), inset 0 2px 0 rgba(255, 255, 255, 0.35), inset 0 -3px 6px rgba(10, 30, 90, 0.25);\n    transition: transform 0.18s, box-shadow 0.18s; .spinner { border-color: rgba(255, 255, 255, 0.4); border-top-color: #fff; }\n    .go { position: absolute; right: 9px; top: 50%; transform: translateY(-50%); width: 44px; height: 44px; display: grid; place-items: center; border-radius: 50%; background: rgba(255, 255, 255, 0.22);\n      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4); transition: transform 0.18s, background 0.18s; }\n    &:hover:not(:disabled) { filter: none; background: linear-gradient(135deg, #3aa6ea 0%, #2a6fd0 50%, var(--blue-b) 100%); transform: translateY(-2px); box-shadow: 0 20px 34px -8px rgba(32, 80, 160, 0.75), inset 0 2px 0 rgba(255, 255, 255, 0.35), inset 0 -3px 6px rgba(10, 30, 90, 0.25);\n      .go { transform: translateY(-50%) translateX(3px); background: rgba(255, 255, 255, 0.32); } }\n    &:active:not(:disabled) { transform: translateY(0); } &:focus-visible { outline: 3px solid rgba(44, 155, 224, 0.5); outline-offset: 3px; } &:disabled { opacity: 0.55; box-shadow: 0 8px 16px -8px rgba(32, 80, 160, 0.4); } }\n\n  .help { text-align: center; font-size: 13px; color: var(--soft); margin: 4px 0 0; }\n  .tagline { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 10px; margin: 0; font-size: 11px; font-weight: 600; letter-spacing: 0.26em; text-transform: uppercase; color: #5d6b88;\n    i { width: 4px; height: 4px; border-radius: 50%; background: var(--blue-a); } } }\n\n// Wider screens: the form sits on its own raised panel so it does not float in empty space.\n@media (min-width: 700px) {\n  .auth-page .form-panel form { max-width: 460px; padding: 48px 48px 40px; border-radius: 44px; background: linear-gradient(145deg, rgba(255, 255, 255, 0.78), rgba(232, 239, 251, 0.78));\n    box-shadow: 18px 18px 44px rgba(150, 166, 204, 0.4), -14px -14px 34px rgba(255, 255, 255, 0.95), inset 0 0 0 2px rgba(255, 255, 255, 0.7); backdrop-filter: blur(8px); }\n  .auth-page .shape { &.s1 { width: 520px; height: 520px; left: -220px; top: -220px; } &.s2 { width: 220px; height: 220px; right: -90px; top: 28%; } &.s3 { width: 320px; height: 320px; left: -140px; bottom: 4%; } &.s4 { width: 620px; height: 620px; right: -270px; bottom: -270px; } }\n}\n@media (max-height: 760px) { .auth-page { .logo-tile { width: 112px; height: 112px; border-radius: 32px; img { width: 72px; height: 72px; } } .form-head h1 { font-size: 30px; } .form-panel { gap: 18px; padding: 24px; } form { gap: 14px; } } }\n@media (min-width: 700px) and (max-height: 760px) { .auth-page .form-panel form { padding: 32px 44px 28px; } }\n\n// A field with a problem: red ring on the soft inputs, message below in the shared error colour.\n.auth-page .with-icon .input.invalid, .auth-page .with-icon .input.invalid:focus { box-shadow: var(--lift), 0 0 0 3px rgba(240, 68, 56, 0.4); }\n.auth-page .field .err { text-align: left; padding-left: 6px; font-size: 13px; }\n// Selected text: a clear blue from the logo, so it stands out on the pale fields. The same blue replaces the browser's autofill fill.\n.auth-page ::selection { background: #2c8de0; color: #fff; }\n.auth-page .input:-webkit-autofill, .auth-page .input:-webkit-autofill:focus { -webkit-text-fill-color: var(--ink); caret-color: var(--ink); box-shadow: var(--lift), inset 0 0 0 100px #d4e6fb; transition: background-color 9999s; }\n@media (max-width: 420px) { .auth-page .tagline { gap: 7px; font-size: 10px; letter-spacing: 0.14em; } }\n\n@keyframes card-in { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: none; } }\n@keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }\n@media (prefers-reduced-motion: reduce) { .auth-page * { animation: none !important; transition: none !important; } }\n",".btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; height: 38px; padding: 0 14px; border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong); background: var(--surface); font-weight: 600; box-shadow: var(--shadow-sm); white-space: nowrap; transition: background 0.15s, border-color 0.15s;\n  svg { width: 16px; height: 16px; } &:hover:not(:disabled) { background: var(--surface-2); }\n  &:disabled { opacity: 0.55; cursor: not-allowed; }\n  &.primary { background: var(--accent); border-color: var(--accent); color: var(--accent-ink); &:hover:not(:disabled) { filter: brightness(0.94); background: var(--accent); } }\n  &.danger { color: var(--danger); border-color: #fda29b; &:hover:not(:disabled) { background: var(--danger-soft); } }\n  &.ghost { border-color: transparent; background: transparent; box-shadow: none; &:hover:not(:disabled) { background: var(--bg); } }\n  &.sm { height: 30px; padding: 0 10px; font-size: 13px; } &.icon { width: 38px; padding: 0; &.sm { width: 30px; } }\n}\n.field { display: flex; flex-direction: column; gap: 6px; min-width: 0;\n  > label, .label { font-size: 13px; font-weight: 600; color: #344054; } .hint { font-size: 12px; color: var(--muted); } .err { font-size: 12px; color: var(--danger); } }\n.input, .select, .textarea { width: 100%; height: 38px; padding: 0 12px; background: var(--surface); border: 1px solid var(--border-strong); border-radius: var(--radius-sm);\n  box-shadow: var(--shadow-sm); transition: border-color 0.15s, box-shadow 0.15s;\n  &::placeholder { color: var(--subtle); } &:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }\n  &:disabled { background: var(--bg); color: var(--muted); } &.invalid { border-color: var(--danger); &:focus { box-shadow: 0 0 0 3px var(--danger-soft); } } }\n.select { appearance: none; padding-right: 32px; cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%23667085' stroke-width='2'%3E%3Cpath d='m4 6 4 4 4-4'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat; background-position: right 10px center; }\n.textarea { height: auto; min-height: 84px; padding: 10px 12px; resize: vertical; }\n.search { position: relative; svg { position: absolute; left: 11px; top: 50%; transform: translateY(-50%); width: 16px; color: var(--subtle); } .input { padding-left: 34px; } }\n.check { display: inline-flex; align-items: center; gap: 8px; cursor: pointer; user-select: none; input { width: 16px; height: 16px; accent-color: var(--accent); } }\n\n.card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); box-shadow: var(--shadow-sm);\n  .card-head { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; padding: 16px 20px; border-bottom: 1px solid var(--border); p { color: var(--muted); font-size: 13px; } }\n  .card-body { padding: 20px; } &.flush .card-body { padding: 0; } }\n.stat { padding: 18px 20px; display: flex; flex-direction: column; gap: 6px; .label { color: var(--muted); font-weight: 550; font-size: 13px; }\n  .value { font-size: 28px; font-weight: 700; letter-spacing: -0.02em; font-variant-numeric: tabular-nums; } .sub { color: var(--muted); font-size: 12px; }\n  &.clickable { cursor: pointer; transition: box-shadow 0.15s, border-color 0.15s; &:hover { border-color: var(--accent); box-shadow: var(--shadow); } } }\n.badge { display: inline-flex; align-items: center; gap: 6px; padding: 2px 9px; border-radius: 999px; font-size: 12px; font-weight: 600; background: var(--bg); color: #344054; white-space: nowrap;\n  &.success { background: var(--success-soft); color: #027a48; } &.danger { background: var(--danger-soft); color: #b42318; }\n  &.warning { background: var(--warning-soft); color: #b54708; } &.accent { background: var(--accent-soft); color: var(--accent); } }\n.chip { border: 1px solid var(--border-strong); background: var(--surface); border-radius: 999px; padding: 5px 12px; font-weight: 600; font-size: 13px; color: var(--muted);\n  &:hover { color: var(--text); } &.on { background: var(--accent-soft); border-color: var(--accent); color: var(--accent); } }\n.tabs { display: flex; gap: 4px; border-bottom: 1px solid var(--border); overflow-x: auto;\n  button { border: 0; background: transparent; padding: 10px 14px; font-weight: 600; color: var(--muted); border-bottom: 2px solid transparent; margin-bottom: -1px; white-space: nowrap;\n    &:hover { color: var(--text); } &.active { color: var(--accent); border-bottom-color: var(--accent); } } }\n.seg { display: inline-flex; padding: 3px; background: var(--bg); border-radius: 9px;\n  button { border: 0; background: transparent; padding: 6px 12px; border-radius: 7px; font-weight: 600; font-size: 13px; color: var(--muted);\n    &.on { background: var(--surface); color: var(--text); box-shadow: var(--shadow); } } }\n.progress { height: 8px; background: var(--bg); border-radius: 999px; overflow: hidden; > i { display: block; height: 100%; background: var(--accent); border-radius: 999px; transition: width 0.4s; } }\n\n.toolbar { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; padding: 14px 20px; border-bottom: 1px solid var(--border);\n  .search { flex: 1 1 240px; max-width: 360px; } .select { width: auto; min-width: 140px; } }\n.table-wrap { overflow: auto; position: relative; }\n.table { width: 100%; border-collapse: separate; border-spacing: 0; min-width: 640px;\n  th { position: sticky; top: 0; background: var(--surface-2); text-align: left; padding: 10px 16px; font-size: 12px; font-weight: 600; color: var(--muted);\n    text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid var(--border); white-space: nowrap; user-select: none;\n    &.sortable { cursor: pointer; &:hover { color: var(--text); } } .arrow { margin-left: 4px; color: var(--accent); } }\n  td { padding: 12px 16px; border-bottom: 1px solid var(--border); vertical-align: middle; }\n  tbody tr { transition: background 0.1s; &:last-child td { border-bottom: 0; } &.clickable { cursor: pointer; } &:hover { background: var(--surface-2); } }\n  .r { text-align: right; } .c { text-align: center; } }\n.pager { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; padding: 12px 20px; border-top: 1px solid var(--border); font-size: 13px; color: var(--muted);\n  .pages { display: flex; gap: 4px; margin-left: auto; align-items: center;\n    button { min-width: 32px; height: 32px; border: 1px solid transparent; background: transparent; border-radius: 8px; font-weight: 600; color: var(--muted);\n      &:hover:not(:disabled) { background: var(--bg); } &.on { background: var(--accent-soft); color: var(--accent); } &:disabled { opacity: 0.4; cursor: default; } } }\n  .select { height: 32px; min-width: 0; width: auto; } }\n\n.skeleton { background: linear-gradient(90deg, #eef1f6 25%, #f6f8fb 37%, #eef1f6 63%); background-size: 400% 100%; animation: shimmer 1.3s ease infinite; border-radius: 6px; height: 14px; }\n@keyframes shimmer { 0% { background-position: 100% 50%; } 100% { background-position: 0 50%; } }\n.empty { padding: 48px 20px; text-align: center; color: var(--muted); svg { width: 36px; height: 36px; color: var(--subtle); margin-bottom: 8px; } strong { display: block; color: var(--text); font-size: 15px; } }\n.alert { padding: 12px 14px; border-radius: var(--radius-sm); font-size: 13px; background: var(--danger-soft); color: #b42318; border: 1px solid #fecdca;\n  &.info { background: var(--accent-soft); color: var(--accent); border-color: transparent; } &.warning { background: var(--warning-soft); color: #b54708; border-color: #fedf89; } }\n.spinner { width: 18px; height: 18px; border: 2px solid var(--border-strong); border-top-color: var(--accent); border-radius: 50%; animation: spin 0.7s linear infinite; display: inline-block; }\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.overlay { position: fixed; inset: 0; background: rgba(16, 24, 40, 0.45); z-index: 60; display: flex; justify-content: flex-end; animation: fade 0.15s; }\n.drawer { width: min(720px, 100%); height: 100%; background: var(--surface); display: flex; flex-direction: column; box-shadow: var(--shadow-lg); animation: slide 0.2s ease;\n  &.narrow { width: min(520px, 100%); } &.wide { width: min(1080px, 100%); } header { display: flex; align-items: center; gap: 12px; padding: 18px 24px; border-bottom: 1px solid var(--border); h2 { font-size: 18px; } }\n  .body { flex: 1; overflow: auto; padding: 24px; } footer { display: flex; gap: 10px; justify-content: flex-end; padding: 14px 24px; border-top: 1px solid var(--border); background: var(--surface-2); } }\n.overlay.center { justify-content: center; align-items: center; .drawer { height: auto; max-height: 90vh; width: min(460px, 94%); border-radius: var(--radius); animation: pop 0.15s ease; } }\n@keyframes fade { from { opacity: 0; } } @keyframes slide { from { transform: translateX(32px); opacity: 0; } } @keyframes pop { from { transform: scale(0.96); opacity: 0; } }\n.toasts { position: fixed; right: 20px; bottom: 20px; z-index: 100; display: flex; flex-direction: column; gap: 8px;\n  .toast { min-width: 260px; max-width: 380px; padding: 12px 14px; border-radius: var(--radius-sm); background: #101828; color: #fff; box-shadow: var(--shadow-lg); animation: slide 0.2s ease;\n    &.error { background: #b42318; } &.success { background: #067647; } } }\n.form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; .full { grid-column: 1 / -1; } }\n@media (max-width: 600px) { .form-grid { grid-template-columns: 1fr; } }\n.chart-box { height: 320px; position: relative; }\n.multi { position: relative; min-width: 0;\n  .multi-trigger { display: flex; align-items: center; gap: 8px; text-align: left; cursor: pointer; color: var(--muted);\n    &.has { color: var(--text); border-color: var(--accent); } .grow { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n    .count { background: var(--accent); color: var(--accent-ink); border-radius: 999px; padding: 0 7px; font-size: 11px; font-weight: 700; } svg { transform: rotate(90deg); color: var(--subtle); flex: none; } }\n  .multi-panel { position: absolute; z-index: 40; top: calc(100% + 6px); left: 0; min-width: 100%; width: max-content; max-width: 360px;\n    background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); box-shadow: var(--shadow-lg); padding: 8px; display: flex; flex-direction: column; gap: 6px; }\n  .multi-actions { display: flex; justify-content: space-between; padding: 0 4px; font-size: 12px; .link:disabled { opacity: 0.4; cursor: default; text-decoration: none; } }\n  .multi-list { max-height: 260px; overflow: auto; display: flex; flex-direction: column;\n    .check { padding: 7px 8px; border-radius: 6px; &:hover { background: var(--bg); } } }\n}\n.link { background: none; border: 0; padding: 0; color: var(--accent); font: inherit; font-weight: 600; cursor: pointer; &:hover { text-decoration: underline; } }\n\n.purpose { background: var(--accent-soft, #eff6ff); border: 1px solid var(--border, #d0d5dd); border-radius: var(--radius-sm); padding: 10px 14px; font-size: 13px; line-height: 1.5; margin-bottom: 16px;\n  summary { cursor: pointer; font-weight: 600; } p { margin: 6px 0 0; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
